import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Badge,
  Form,
  Card,
  Modal,
} from "react-bootstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { toast } from "react-toastify";
import moment from "moment";
import { fetchProjectDetails, updateProject } from "../Api/ViewProjects";
import "./ProjectView.css";
import { getTasksByProject } from "../Api/TaskMaster";
import {
  startTaskWork,
  stopTaskWork,
  getTaskAssignmentsByTaskId,
} from "../Api/TaskMaster";
import TaskEditModal from "./TaskEditModal";
import TaskViewSidebar from "./TaskViewSidebar";
import { getTeamsByOrg, getTeamById } from "../Api/TeamMaster";
import { getUsersByIds } from "../Api/Auth";
import { getTicketsByProjectId } from "../Api/TicketApiOrg";
import {
  getAssignmentsByTicketId,
  startWork,
  stopWork,
} from "../Api/TicketApiOrg";
import TaskTemplateModal from "./TaskTemplateModal";
import { getTemplatesByOrg, deleteTaskTemplate } from "../Api/TaskTemplate";
import {
  getPartnersByOrg,
  createPartner,
  updatePartner,
  getPartnersByProject,
} from "../Api/PartnerMaster";
import PartnerModal from "./PartnerModal";
import CommercialModal from "./CommercialModal";
import ResourceModal from "./ResourceModal";
import {
  deleteResource,
  fetchResourcesByProject,
} from "../Api/projectResourceService";
import {
  fetchResourceById,
  fetchProjectTypes,
  fetchProjectTypeById,
  fetchCustomersByOrgId,
  fetchResourceByOrgId,
} from "../Api/InvoiceApi";
import {
  uploadMultipleProjectDocuments,
  getDocumentsByProject,
  deleteDocumentWithFile,
  downloadDocument,
  validateFile,
  handleFileDownload,
  updateProjectFavourite,
} from "../Api/ProjectMaster";
import { getAllProjectStatus } from "../Api/ProjectStatusApi";
import MilestoneModal from "./MilestoneModal";
import {
  getAllMilestones,
  getMilestonesByProjectAndOrg,
  createMilestone,
  updateMilestone,
} from "../Api/MilestoneMaster";
import StageModal from "./StageModal";
import {
  fetchStagesByProject,
  createStage,
  updateStage,
} from "../Api/StageMaster";
import {
  getTasksByProjectAndStage,
  createTasksFromExcel,
} from "../Api/TaskMaster";
import { getCommercialsByProject } from "../Api/CommercialMaster";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import * as XLSX from "xlsx";
const ProjectView = () => {
  // =========================================================================
  // STATE DECLARATIONS
  // =========================================================================

  // User and Project State
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const orgId = userDetails?.organisationId;
  const { projectId } = useParams();
  const navigate = useNavigate();

  // UI State
  const [activeTab, setActiveTab] = useState("overview");
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showTaskSidebar, setShowTaskSidebar] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [expandedMilestones, setExpandedMilestones] = useState({});

  // Project Data State
  const [project, setProject] = useState(null);
  const [originalProject, setOriginalProject] = useState(null);
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [projectStatusesLoading, setProjectStatusesLoading] = useState(false);
  const [projectTypes, setProjectTypes] = useState([]);
  const [projectTypeLoading, setProjectTypeLoading] = useState(false);
  const [projectTypeDesc, setProjectTypeDesc] = useState("");
  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(false);
  const [selectedCustomerName, setSelectedCustomerName] = useState("");

  // Team and Resource State
  const [teams, setTeams] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const [teamData, setTeamData] = useState(null);
  const [teamMemberDetails, setTeamMemberDetails] = useState([]);
  const [loadingTeamMembers, setLoadingTeamMembers] = useState(false);
  const [resourcesByOrg, setResourcesByOrg] = useState([]);
  const [resourcesByOrgLoading, setResourcesByOrgLoading] = useState(false);
  const [projectManagerName, setProjectManagerName] = useState("");
  const [salespersonName, setSalespersonName] = useState("");
  const [loadingManager, setLoadingManager] = useState(false);
  const [loadingSalesperson, setLoadingSalesperson] = useState(false);

  // Task State
  const [tasks, setTasks] = useState([]);
  const [tasksLoading, setTasksLoading] = useState(false);
  const [taskAssignedUsers, setTaskAssignedUsers] = useState({});
  // Task Assignment Dialog State
  const [showTaskDialog, setShowTaskDialog] = useState(false);
  const [taskForDialog, setTaskForDialog] = useState(null);
  const [taskAssignments, setTaskAssignments] = useState([]);
  const [taskAssignLoading, setTaskAssignLoading] = useState(false);
  const [assignTaskUserId, setAssignTaskUserId] = useState("");
  const [taskAssignmentsByTask, setTaskAssignmentsByTask] = useState({}); // { [taskId]: [assignments] }

  // Add near other state declarations
  const [showTaskOptions, setShowTaskOptions] = useState(false);
  const [showExcelUploadModal, setShowExcelUploadModal] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [uploadingExcel, setUploadingExcel] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredStageTasks, setFilteredStageTasks] = useState({});

  // Stage State
  const [stages, setStages] = useState([]);
  const [stagesLoading, setStagesLoading] = useState(false);
  const [showStageModal, setShowStageModal] = useState(false);
  const [editingStage, setEditingStage] = useState(null);
  const [stageTasks, setStageTasks] = useState({});
  const [tasksLoadingByStage, setTasksLoadingByStage] = useState({});

  // Ticket State
  const [tickets, setTickets] = useState([]);
  const [ticketsLoading, setTicketsLoading] = useState(false);

  // Ticket quick dialog + assignments
  const [showTicketDialog, setShowTicketDialog] = useState(false);
  const [ticketForDialog, setTicketForDialog] = useState(null);
  const [assignmentsByTicket, setAssignmentsByTicket] = useState({}); // { [ticketId]: [...] }
  const [assignmentsLoading, setAssignmentsLoading] = useState(false);
  const [assignLoading, setAssignLoading] = useState(false);
  const [assignUserId, setAssignUserId] = useState(""); // selected team member userId

  // Template State
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  // Partner State
  const [partners, setPartners] = useState([]);
  const [partnersLoading, setPartnersLoading] = useState(false);
  const [showPartnerModal, setShowPartnerModal] = useState(false);
  const [editingPartner, setEditingPartner] = useState(null);

  // Commercial State
  const [commercials, setCommercials] = useState([]);
  const [commercialsLoading, setCommercialsLoading] = useState(false);
  const [showCommercialModal, setShowCommercialModal] = useState(false);
  const [editingCommercial, setEditingCommercial] = useState(null);

  // Milestone State
  const [milestones, setMilestones] = useState([]);
  const [milestonesLoading, setMilestonesLoading] = useState(false);
  const [showMilestoneModal, setShowMilestoneModal] = useState(false);
  const [editingMilestone, setEditingMilestone] = useState(null);
  const [milestoneTasks, setMilestoneTasks] = useState({});

  // Resource Allocation State
  const [resources, setResources] = useState([]);
  const [resourcesLoading, setResourcesLoading] = useState(false);
  const [showResourceModal, setShowResourceModal] = useState(false);
  const [editingResource, setEditingResource] = useState(null);
  const [resourceDetails, setResourceDetails] = useState({});
  const [loadingResourceDetails, setLoadingResourceDetails] = useState({});

  // Document State
  const [documents, setDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  const [uploadingDocuments, setUploadingDocuments] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [documentTitle, setDocumentTitle] = useState("");
  const [documentType, setDocumentType] = useState("");

  // Available task fields configuration
  const availableFields = [
    {
      field: "taskName",
      displayName: "Task Name",
      type: "text",
      required: true,
    },
    {
      field: "taskDescription",
      displayName: "Task Description",
      type: "textarea",
      required: false,
    },
    {
      field: "assignedTo",
      displayName: "Assigned To",
      type: "select",
      required: false,
    },
    {
      field: "taskStartDate",
      displayName: "Planned Start Date",
      type: "date",
      required: false,
    },
    {
      field: "taskEndDate",
      displayName: "Planned End Date",
      type: "date",
      required: false,
    },
    {
      field: "actualStartDate",
      displayName: "Actual Start Date",
      type: "date",
      required: false,
    },
    {
      field: "actualEndDate",
      displayName: "Actual End Date",
      type: "date",
      required: false,
    },
    {
      field: "taskType",
      displayName: "Task Type",
      type: "select",
      required: false,
    },
    {
      field: "taskPriority",
      displayName: "Priority",
      type: "select",
      required: false,
    },
    {
      field: "taskStatus",
      displayName: "Status",
      type: "select",
      required: false,
    },
  ];

  // =========================================================================
  // GENERAL PROJECT DATA FUNCTIONS
  // =========================================================================

  // Load main project details
  const loadProjectDetails = async () => {
    try {
      const data = await fetchProjectDetails(projectId);
      console.log("Fetched project details:", data);
      setProject(data);
      setOriginalProject(data);
    } catch (error) {
      toast.error("Error loading project details");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle field changes in edit mode
  const handleFieldChange = (field, value) => {
    if (!isEditing) {
      setIsEditing(true);
    }
    setProject((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Save project changes
  const handleSave = async () => {
    if (!project) return;

    setSaving(true);
    try {
      const updateData = {
        prTitle: project.prTitle,
        prDescription: project.prDescription,
        prTags: project.prTags,
        prStartDate: project.prStartDate,
        prEndDate: project.prEndDate,
        prClient: project.prClient,
        prTypes: project.prTypes,
        teamAssigned: project.teamId,
        projectStatus: project.projectStatus,
        projectCategory: project.projectCategory,
        comments: project.comments,
        salespersonCode: project.salespersonCode,
        currentProjectManager: project.currentProjectManager,
        usersId: project.usersId,
      };

      await updateProject(project.projectId, updateData);
      setOriginalProject(project);
      setIsEditing(false);
      toast.success("Project updated successfully");

      // Refresh the manager and salesperson names after update
      if (project.currentProjectManager) {
        fetchProjectManagerName(project.currentProjectManager);
      }
      if (project.salespersonCode) {
        fetchSalespersonName(project.salespersonCode);
      }
    } catch (error) {
      console.error("Error updating project:", error);
      toast.error("Failed to update project");
    } finally {
      setSaving(false);
    }
  };

  // Cancel editing
  const handleCancel = () => {
    setProject(originalProject);
    setIsEditing(false);
  };

  // Toggle favorite status
  const handleToggleFavorite = async () => {
    if (!project || !userId) return;

    const newFavoriteStatus = !project.isFavourite;

    try {
      // Optimistically update UI
      setProject((prev) => ({
        ...prev,
        isFavourite: newFavoriteStatus,
      }));

      // Call API
      await updateProjectFavourite(
        project.projectId,
        newFavoriteStatus,
        userId
      );

      // Update original project state
      setOriginalProject((prev) => ({
        ...prev,
        isFavourite: newFavoriteStatus,
      }));

      toast.success(
        newFavoriteStatus
          ? "Project added to favorites!"
          : "Project removed from favorites!"
      );
    } catch (error) {
      // Revert on error
      setProject((prev) => ({
        ...prev,
        isFavourite: !newFavoriteStatus,
      }));

      console.error("Error updating favorite status:", error);
      toast.error("Failed to update favorite status");
    }
  };

  // =========================================================================
  // OVERVIEW TAB FUNCTIONS
  // =========================================================================

  // Load project statuses
  const loadProjectStatuses = async () => {
    setProjectStatusesLoading(true);
    try {
      const statusesData = await getAllProjectStatus();
      console.log("Loaded project statuses:", statusesData);
      setProjectStatuses(statusesData || []);
    } catch (error) {
      console.error("Error loading project statuses:", error);
      toast.error("Failed to load project statuses");
      setProjectStatuses([]);
    } finally {
      setProjectStatusesLoading(false);
    }
  };

  // Load customers
  const loadCustomers = async () => {
    if (!orgId) return;

    setCustomersLoading(true);
    try {
      const customersData = await fetchCustomersByOrgId(orgId);
      console.log("Loaded customers:", customersData);
      setCustomers(customersData || []);
    } catch (error) {
      console.error("Error loading customers:", error);
      toast.error("Failed to load customers");
      setCustomers([]);
    } finally {
      setCustomersLoading(false);
    }
  };

  // Handle customer selection
  const handleCustomerChange = (customerCode) => {
    const selectedCustomer = customers.find(
      (cust) => cust.customerCode === customerCode
    );
    if (selectedCustomer) {
      setSelectedCustomerName(selectedCustomer.name);
    }
    handleFieldChange("prClient", customerCode);
  };

  // Load teams
  const loadTeams = async () => {
    try {
      const teamsData = await getTeamsByOrg(orgId);
      console.log("Loaded teams:", teamsData);
      setTeams(teamsData);
    } catch (error) {
      console.error("Error loading teams:", error);
      toast.error("Failed to load teams");
    }
  };

  // Fetch project types
  const fetchProjectTypesList = async () => {
    if (!orgId) return;

    setProjectTypeLoading(true);
    try {
      const projectTypesData = await fetchProjectTypes(orgId);
      console.log("Loaded project types:", projectTypesData);
      setProjectTypes(projectTypesData || []);
    } catch (error) {
      console.error("Error loading project types:", error);
      toast.error("Failed to load project types");
      setProjectTypes([]);
    } finally {
      setProjectTypeLoading(false);
    }
  };

  // Fetch project type description
  const fetchProjectTypeDescription = async (projectTypeId) => {
    if (!projectTypeId) {
      setProjectTypeDesc("");
      return;
    }

    try {
      const response = await fetchProjectTypeById(projectTypeId);
      console.log("Project Type details:", response);
      setProjectTypeDesc(response.projectTypeDesc || projectTypeId);
    } catch (error) {
      console.error("Error fetching project type description:", error);
      setProjectTypeDesc(projectTypeId);
    }
  };

  // Fetch project manager name
  const fetchProjectManagerName = async (managerCode) => {
    if (!managerCode) {
      setProjectManagerName("Not assigned");
      return;
    }

    setLoadingManager(true);
    try {
      const response = await fetchResourceById(managerCode);
      console.log("Project Manager details:", response);
      setProjectManagerName(response.name || managerCode);
    } catch (error) {
      console.error("Error fetching project manager details:", error);
      setProjectManagerName(managerCode);
    } finally {
      setLoadingManager(false);
    }
  };

  // Fetch salesperson name
  const fetchSalespersonName = async (salespersonCode) => {
    if (!salespersonCode) {
      setSalespersonName("Not assigned");
      return;
    }

    setLoadingSalesperson(true);
    try {
      const response = await fetchResourceById(salespersonCode);
      console.log("Salesperson details:", response);
      setSalespersonName(response.name || salespersonCode);
    } catch (error) {
      console.error("Error fetching salesperson details:", error);
      setSalespersonName(salespersonCode);
    } finally {
      setLoadingSalesperson(false);
    }
  };

  // Load resources by organization
  const loadResourcesByOrg = async () => {
    if (!orgId) return;

    setResourcesByOrgLoading(true);
    try {
      const resourcesData = await fetchResourceByOrgId(orgId);
      console.log("Loaded resources by org:", resourcesData);
      setResourcesByOrg(resourcesData || []);
    } catch (error) {
      console.error("Error loading resources by org:", error);
      toast.error("Failed to load resources");
      setResourcesByOrg([]);
    } finally {
      setResourcesByOrgLoading(false);
    }
  };

  // =========================================================================
  // TASKS TAB FUNCTIONS
  // =========================================================================

  // Load project tasks

  // In the loadProjectTasksByStages function, modify it to handle tasks without stages:
  const loadProjectTasksByStages = async () => {
    if (!project?.projectId) {
      setTasksLoading(false);
      return;
    }

    setTasksLoading(true);
    try {
      // First, load all tasks for the project
      const allTasksData = await getTasksByProject(project.projectId);
      console.log("All project tasks:", allTasksData);

      // If no stages exist, just set tasks without stage grouping
      if (!stages || stages.length === 0) {
        setStageTasks({ "no-stage": allTasksData || [] });
        setFilteredStageTasks({ "no-stage": allTasksData || [] });

        // Fetch user details for assigned tasks
        if (allTasksData && allTasksData.length > 0) {
          await fetchTaskAssignedUsers(allTasksData);
          await loadAllTaskAssignments(allTasksData);
        }

        setTasksLoadingByStage({ "no-stage": false });
        return;
      }

      const tasksByStage = {};
      const loadingStates = {};

      // Initialize loading states for each stage + "No Stage"
      stages.forEach((stage) => {
        loadingStates[stage.stageId] = true;
      });
      loadingStates["no-stage"] = true;

      setTasksLoadingByStage(loadingStates);

      // Separate tasks by stage
      const tasksWithoutStage = [];

      (allTasksData || []).forEach((task) => {
        if (task.stageBelong) {
          const stageId = task.stageBelong;
          if (!tasksByStage[stageId]) {
            tasksByStage[stageId] = [];
          }
          tasksByStage[stageId].push(task);
        } else {
          tasksWithoutStage.push(task);
        }
      });

      // Add tasks without stage to the tasksByStage object
      if (tasksWithoutStage.length > 0) {
        tasksByStage["no-stage"] = tasksWithoutStage;
      }

      // Update loading states
      const updatedLoadingStates = { ...loadingStates };
      Object.keys(tasksByStage).forEach((stageId) => {
        updatedLoadingStates[stageId] = false;
      });
      setTasksLoadingByStage(updatedLoadingStates);

      // Fetch user details and assignments
      if (allTasksData && allTasksData.length > 0) {
        await fetchTaskAssignedUsers(allTasksData);
        await loadAllTaskAssignments(allTasksData);
      }

      setStageTasks(tasksByStage);
      setFilteredStageTasks(tasksByStage); // Initialize filtered tasks
    } catch (error) {
      console.error("Error loading project tasks by stages:", error);
      toast.error("Failed to load project tasks");
      setStageTasks({});
      setFilteredStageTasks({});
    } finally {
      setTasksLoading(false);
    }
  };

  // Fetch user details for assigned tasks
  const fetchTaskAssignedUsers = async (tasks) => {
    const assignedUserIds = tasks
      .map((task) => task.assignedTo)
      .filter((userId) => userId && userId !== "")
      .map((id) => parseInt(id))
      .filter((id) => !isNaN(id));

    if (assignedUserIds.length === 0) return;

    try {
      const response = await getUsersByIds(assignedUserIds);
      if (response && response.users) {
        const usersMap = {};
        response.users.forEach((user) => {
          usersMap[user.userId] = user.username;
        });
        setTaskAssignedUsers(usersMap);
      }
    } catch (error) {
      console.error("Error fetching task assigned users:", error);
    }
  };

  // Task edit modal handlers
  const handleEditTask = (taskId) => {
    setSelectedTaskId(taskId);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedTaskId(null);
    setSelectedTask(null);
  };

  const handleTaskUpdated = () => {
    loadProjectTasks();
  };

  // Handle task name clicks
  const handleTaskNameClick = (taskId) => {
    setSelectedTaskId(taskId);
    setShowTaskSidebar(true);
  };

  // ======================= TASK ASSIGNMENT FUNCTIONS =======================

  // Load assignments for all tasks in the table
  const loadAllTaskAssignments = async (tasks) => {
    if (!tasks || tasks.length === 0) return;

    try {
      const assignmentsMap = {};

      // Fetch assignments for each task
      for (const task of tasks) {
        try {
          const assignments = await getTaskAssignmentsByTaskId(task.taskId);
          assignmentsMap[task.taskId] = assignments || [];
        } catch (error) {
          console.error(
            `Error loading assignments for task ${task.taskId}:`,
            error
          );
          assignmentsMap[task.taskId] = [];
        }
      }

      setTaskAssignmentsByTask(assignmentsMap);
    } catch (error) {
      console.error("Error loading task assignments:", error);
    }
  };

  // Load assignments for a specific task
  const loadTaskAssignmentsForTask = async (taskId) => {
    try {
      const assignments = await getTaskAssignmentsByTaskId(taskId);
      setTaskAssignmentsByTask((prev) => ({
        ...prev,
        [taskId]: assignments || [],
      }));
      return assignments || [];
    } catch (error) {
      console.error(`Error loading assignments for task ${taskId}:`, error);
      setTaskAssignmentsByTask((prev) => ({
        ...prev,
        [taskId]: [],
      }));
      return [];
    }
  };

  // Update the loadProjectTasks function to also load assignments:
  const loadProjectTasks = async () => {
    if (!project?.projectId) return;

    setTasksLoading(true);
    try {
      const tasksData = await getTasksByProject(project.projectId);
      console.log("Loaded tasks:", tasksData);
      setTasks(tasksData);

      // Load assignments for all tasks
      await loadAllTaskAssignments(tasksData);

      // Fetch user details for assigned tasks (keep this for fallback)
      await fetchTaskAssignedUsers(tasksData);
    } catch (error) {
      console.error("Error loading tasks:", error);
      toast.error("Failed to load project tasks");
    } finally {
      setTasksLoading(false);
    }
  };

  // Helper function to get active assignments for a task
  const getActiveAssignmentsForTask = (taskId) => {
    const assignments = taskAssignmentsByTask[taskId] || [];
    return assignments.filter(
      (assign) => assign.isActive === true || assign.isActive === 1
    );
  };

  // Helper function to get all assigned users for a task (including historical)
  const getAllAssignedUsersForTask = (taskId) => {
    const assignments = taskAssignmentsByTask[taskId] || [];
    return assignments.map((assign) => assign.assignedUserId);
  };

  // Helper function to get current assigned users (active or most recent)
  const getCurrentAssignedUsersForTask = (taskId) => {
    const assignments = taskAssignmentsByTask[taskId] || [];

    // First, get active assignments
    const activeAssignments = assignments.filter(
      (assign) => assign.isActive === true || assign.isActive === 1
    );

    if (activeAssignments.length > 0) {
      return activeAssignments;
    }

    // If no active assignments, get the most recent completed assignment
    if (assignments.length > 0) {
      const sorted = [...assignments].sort(
        (a, b) =>
          new Date(b.endTime || b.startTime) -
          new Date(a.endTime || a.startTime)
      );
      return [sorted[0]];
    }

    return [];
  };

  // Add this helper function
  const getUsernameFromId = (userId) => {
    if (!userId) return "Unknown";

    // Try to find in teamMemberDetails first
    const userDetail = teamMemberDetails.find(
      (user) => String(user.userId) === String(userId)
    );

    if (userDetail) return userDetail.username;

    // Fallback to taskAssignedUsers
    const mappedUser = taskAssignedUsers[parseInt(userId)];
    if (mappedUser) return mappedUser;

    return userId; // Return ID if no name found
  };

  // Refresh task assignments
  // Refresh task assignments with cache busting
  const refreshTaskAssignments = async (taskId) => {
    try {
      setTaskAssignLoading(true);
      const data = await getTaskAssignmentsByTaskId(taskId);

      // Update both the dialog state and the main assignments map
      setTaskAssignments(data || []);
      setTaskAssignmentsByTask((prev) => ({
        ...prev,
        [taskId]: data || [],
      }));

      return data || [];
    } catch (err) {
      console.error("Error loading task assignments:", err);
      toast.error("Failed to load task assignments");
      return [];
    } finally {
      setTaskAssignLoading(false);
    }
  };

  // Open dialog for a specific task
  const openTaskDialog = async (task) => {
    // Reset previous assignments
    setTaskAssignments([]);
    setTaskForDialog(task);
    setShowTaskDialog(true);
    setAssignTaskUserId("");

    // Load fresh assignments for this specific task
    const freshAssignments = await loadTaskAssignmentsForTask(task.taskId);
    setTaskAssignments(freshAssignments);
  };

  // Also update the closeTaskDialog to reset assignments
  const closeTaskDialog = () => {
    setShowTaskDialog(false);
    setTaskForDialog(null);
    setTaskAssignments([]); // Clear assignments when closing
    setAssignTaskUserId("");
  };

  // Get active assignment for user on this task
  const getActiveAssignmentForTaskUser = (taskId, userId) => {
    const list = taskAssignments || [];
    return list.find(
      (x) =>
        String(x.assignedUserId) === String(userId) &&
        (x.isActive === true || x.isActive === 1)
    );
  };

  // Handle assign/start
  const handleAssignAndStartTask = async () => {
    if (!taskForDialog?.taskId) {
      toast.error("No task selected");
      return;
    }
    if (!assignTaskUserId) {
      toast.error("Please select a team member");
      return;
    }

    const active = getActiveAssignmentForTaskUser(
      taskForDialog.taskId,
      assignTaskUserId
    );
    if (active) {
      toast.info("This user already has an active session on this task");
      return;
    }

    try {
      setTaskAssignLoading(true);
      await startTaskWork(taskForDialog.taskId, assignTaskUserId, orgId);
      toast.success("Task work session started");
      await refreshTaskAssignments(taskForDialog.taskId);
      setAssignTaskUserId("");
    } catch (err) {
      console.error("Start work failed:", err);
      toast.error(
        err?.response?.data || err?.message || "Failed to start work"
      );
    } finally {
      setTaskAssignLoading(false);
    }
  };

  // Stop work
  const handleStopTaskWork = async (assignmentId) => {
    if (!assignmentId) return;
    try {
      await stopTaskWork(assignmentId);
      toast.success("Stopped task work session");
      await refreshTaskAssignments(taskForDialog?.taskId);
    } catch (err) {
      console.error("Stop work failed:", err);
      toast.error(err?.response?.data || err?.message || "Failed to stop work");
    }
  };

  // Realtime filtering
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredStageTasks(stageTasks);
      return;
    }

    const lowerQuery = searchQuery.toLowerCase();
    const filtered = {};

    Object.keys(stageTasks).forEach((stageId) => {
      filtered[stageId] = stageTasks[stageId].filter(
        (task) =>
          task.taskName?.toLowerCase().includes(lowerQuery) ||
          task.taskDescription?.toLowerCase().includes(lowerQuery)
      );
    });

    setFilteredStageTasks(filtered);
  }, [searchQuery, stageTasks]);

  // =========================================================================
  // EXCEL UPLOAD FUNCTIONS
  // =========================================================================

  // Handle task creation method selection
  const handleAddTaskClick = () => {
    setShowTaskOptions(true);
  };

  // Handle Excel upload method
  const handleExcelUploadClick = () => {
    setShowTaskOptions(false);
    setShowExcelUploadModal(true);
  };

  // Handle manual task creation
  const handleManualTaskClick = () => {
    setShowTaskOptions(false);
    navigate(`/addTask?projectId=${project.projectId}`);
  };

  // Handle Excel file selection
  // Update the handleExcelFileSelect function
  const handleExcelFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Check file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      toast.error("File size must be less than 10MB");
      event.target.value = "";
      return;
    }

    // Get file extension
    const fileName = file.name.toLowerCase();
    const isExcel = fileName.endsWith(".xlsx") || fileName.endsWith(".xls");
    const isCSV = fileName.endsWith(".csv");

    if (!isExcel && !isCSV) {
      toast.error("Please select an Excel (.xlsx, .xls) or CSV file");
      event.target.value = "";
      return;
    }

    // If it's a CSV file, convert it to Excel format
    if (isCSV) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const csvContent = e.target.result;

          // Parse CSV
          const workbook = XLSX.read(csvContent, { type: "string" });

          // Convert to XLSX format
          const excelData = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          // Create new Excel file
          const excelBlob = new Blob([excelData], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const excelFileName = file.name.replace(".csv", ".xlsx");
          const excelFile = new File([excelBlob], excelFileName, {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          setExcelFile(excelFile);
          toast.info("CSV file converted to Excel format.");
        } catch (error) {
          console.error("Error converting CSV to Excel:", error);
          toast.error(
            "Failed to convert CSV file. Please upload an Excel file instead."
          );
          event.target.value = "";
        }
      };
      reader.readAsText(file);
    } else {
      // It's already an Excel file
      setExcelFile(file);
    }
  };
  // In handleExcelUpload function
  const handleExcelUpload = async () => {
    if (!excelFile) {
      toast.error("Please select an Excel file to upload");
      return;
    }

    if (!orgId || !project?.projectId) {
      toast.error("Organization ID or Project ID is missing");
      return;
    }

    setUploadingExcel(true);

    try {
      const formData = new FormData();
      formData.append("excelFile", excelFile);
      formData.append("orgId", orgId);
      formData.append("projectBelong", project.projectId);

      // Add createdBy if needed
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      if (userDetails?.userId) {
        formData.append("createdBy", userDetails.userId);
      }

      // Optional: Add other parameters if needed
      formData.append("taskStatus", "Pending"); // Default status
      formData.append("taskPriority", "Medium"); // Default priority

      console.log("=== FRONTEND DEBUG ===");
      console.log("FormData contents:");
      for (let pair of formData.entries()) {
        console.log(pair[0] + ": ", pair[1]);
      }
      console.log("File details:", {
        name: excelFile.name,
        size: excelFile.size,
        type: excelFile.type,
        lastModified: excelFile.lastModified,
      });

      // Call the Excel upload API
      console.log("Calling API...");
      const response = await createTasksFromExcel(formData);

      console.log("API Response received:", response);

      // Check for success flag
      if (response.success || response.message) {
        const successMessage =
          response.message ||
          `${
            response.createdCount || "Tasks"
          } created successfully from Excel!`;
        toast.success(successMessage);
        setShowExcelUploadModal(false);
        setExcelFile(null);

        // Refresh tasks list
        loadProjectTasks();
      } else {
        toast.error(response.message || "Failed to create tasks from Excel");
      }
    } catch (error) {
      console.error("=== FRONTEND ERROR ===");
      console.error("Full error:", error);
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);

      // Show more specific error
      if (error.message.includes("File contains corrupted data")) {
        toast.error(
          "The Excel file format is invalid. Please download and use the template."
        );
      } else if (error.message.includes("instance of entity type")) {
        toast.error("Database error. Please try again or contact support.");
      } else if (error.message.includes("No response from server")) {
        toast.error(
          "Cannot connect to server. Please check your network connection."
        );
      } else if (error.message.includes("timeout")) {
        toast.error(
          "Request timed out. The file might be too large or server is busy."
        );
      } else {
        // Show the actual error message from backend
        toast.error(`Upload failed: ${error.message}`);
      }
    } finally {
      setUploadingExcel(false);
    }
  };

  // Close Excel upload modal
  const handleCloseExcelUploadModal = () => {
    setShowExcelUploadModal(false);
    setExcelFile(null);
  };

  // Download Excel template
  const handleDownloadTemplate = () => {
    // Create sample Excel data
    const templateData = [
      [
        "taskName",
        "taskDescription",
        "assignedTo",
        "taskStartDate",
        "taskEndDate",
        "taskPriority",
        "taskStatus",
      ],
      [
        "Task 1",
        "Description for task 1",
        "user123",
        "2024-01-15",
        "2024-01-20",
        "High",
        "Pending",
      ],
      [
        "Task 2",
        "Description for task 2",
        "user456",
        "2024-01-16",
        "2024-01-22",
        "Medium",
        "In Progress",
      ],
      [
        "Task 3",
        "Description for task 3",
        "",
        "2024-01-17",
        "2024-01-25",
        "Low",
        "Not Started",
      ],
    ];

    // Convert to CSV
    const csvContent = templateData.map((row) => row.join(",")).join("\n");

    // Create download link
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "task_upload_template.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    toast.info("Excel template downloaded. Fill in your tasks and upload.");
  };

  // =========================================================================
  // STAGES TAB FUNCTIONS
  // =========================================================================

  // Load project stages
  const loadProjectStages = async () => {
    if (!projectId) return;

    setStagesLoading(true);
    try {
      const stagesData = await fetchStagesByProject(projectId);
      console.log("Loaded project stages:", stagesData);
      setStages(stagesData || []);
    } catch (error) {
      console.error("Error loading project stages:", error);
      toast.error("Failed to load project stages");
      setStages([]);
    } finally {
      setStagesLoading(false);
    }
  };

  // Stage modal handlers
  const handleCreateStage = () => {
    setEditingStage(null);
    setShowStageModal(true);
  };

  const handleEditStage = (stage) => {
    setEditingStage(stage);
    setShowStageModal(true);
  };

  const handleCloseStageModal = () => {
    setShowStageModal(false);
    setEditingStage(null);
  };

  const handleStageSaved = () => {
    loadProjectStages();
    handleCloseStageModal();
  };

  // Handle stage updates
  const handleUpdateStage = async (stageId, updatedData) => {
    try {
      await updateStage(stageId, updatedData);
      toast.success("Stage updated successfully");
      loadProjectStages();
    } catch (error) {
      console.error("Error updating stage:", error);
      toast.error("Failed to update stage");
    }
  };

  // =========================================================================
  // TEAM TAB FUNCTIONS
  // =========================================================================

  // Fetch user details for team members
  const fetchTeamMemberDetails = async (userIds) => {
    if (!userIds || userIds.length === 0) {
      setTeamMemberDetails([]);
      return;
    }

    try {
      setLoadingTeamMembers(true);
      console.log("Fetching user details for team member IDs:", userIds);

      // Convert string IDs to numbers for the API
      const numericUserIds = userIds
        .map((id) => parseInt(id))
        .filter((id) => !isNaN(id));

      if (numericUserIds.length === 0) {
        console.warn("No valid user IDs to fetch for team members");
        setTeamMemberDetails([]);
        return;
      }

      const response = await getUsersByIds(numericUserIds);
      console.log("Fetched Team Member Details:", response);

      if (response && response.users) {
        setTeamMemberDetails(response.users);
      } else {
        setTeamMemberDetails([]);
        console.warn("No user details found for team members");
      }
    } catch (error) {
      console.error("Error fetching team member details:", error);
      toast.error("Error loading team member details");
      setTeamMemberDetails([]);
    } finally {
      setLoadingTeamMembers(false);
    }
  };

  // =========================================================================
  // TICKET TAB FUNCTIONS
  // =========================================================================

  // Load tickets for the project
  const loadProjectTickets = async () => {
    if (!project?.projectId) return;

    setTicketsLoading(true);
    try {
      const ticketsData = await getTicketsByProjectId(project.projectId);
      console.log("Loaded tickets:", ticketsData);
      setTickets(ticketsData);
    } catch (error) {
      console.error("Error loading tickets:", error);
      toast.error("Failed to load project tickets");
    } finally {
      setTicketsLoading(false);
    }
  };

  // Handle converting ticket to task
  const handleConvertToTask = (ticket) => {
    navigate(`/addTask?projectId=${projectId}&ticketId=${ticket.ticketId}`);
  };

  // Load assignments for a ticket
  const refreshAssignments = async (ticketId) => {
    try {
      setAssignmentsLoading(true);
      const data = await getAssignmentsByTicketId(ticketId);
      console.log(data);
      setAssignmentsByTicket((prev) => ({ ...prev, [ticketId]: data || [] }));
    } catch (err) {
      console.error("Error loading assignments:", err);
      // toast.error("Failed to load assignments");
    } finally {
      setAssignmentsLoading(false);
    }
  };

  // Open the small ticket dialog
  const openTicketDialog = async (ticket) => {
    setTicketForDialog(ticket);
    setShowTicketDialog(true);
    setAssignUserId("");
    await refreshAssignments(ticket.ticketId);
  };

  // Close dialog
  const closeTicketDialog = () => {
    setShowTicketDialog(false);
    setTicketForDialog(null);
    setAssignUserId("");
  };

  // Get the active assignment (if any) for a user on this ticket
  const getActiveAssignmentForUser = (ticketId, userId) => {
    const list = assignmentsByTicket[ticketId] || [];
    return list.find(
      (x) =>
        String(x.assignedUserId) === String(userId) &&
        (x.isActive === true || x.isActive === 1)
    );
  };

  // Assign & start work for the selected team member
  const handleAssignAndStart = async () => {
    if (!ticketForDialog?.ticketId) {
      toast.error("No ticket selected");
      return;
    }
    if (!assignUserId) {
      toast.error("Please select a team member");
      return;
    }

    // Prevent duplicate active sessions
    const active = getActiveAssignmentForUser(
      ticketForDialog.ticketId,
      assignUserId
    );
    if (active) {
      toast.info("This user already has an active session on this ticket");
      return;
    }
    console.log(orgId);
    try {
      setAssignLoading(true);
      await startWork(ticketForDialog.ticketId, assignUserId, orgId);
      toast.success("Assignment started");
      await refreshAssignments(ticketForDialog.ticketId);
      setAssignUserId("");
    } catch (err) {
      console.error("Start work failed:", err);
      toast.error(
        err?.response?.data || err?.message || "Failed to start assignment"
      );
    } finally {
      setAssignLoading(false);
    }
  };

  // Stop an active assignment
  const handleStop = async (assignmentId) => {
    if (!assignmentId) return;

    try {
      await stopWork(assignmentId);
      toast.success("Stopped");
      if (ticketForDialog?.ticketId) {
        await refreshAssignments(ticketForDialog.ticketId);
      }
    } catch (err) {
      console.error("Stop work failed:", err);
      toast.error(err?.response?.data || err?.message || "Failed to stop");
    }
  };

  useEffect(() => {
    if (tickets.length > 0) {
      tickets.forEach((ticket) => refreshAssignments(ticket.ticketId));
    }
  }, [tickets]);

  // Format a duration in hours with 2 decimals
  const fmtHours = (h) => (h == null ? "-" : Number(h).toFixed(2));

  // =========================================================================
  // WORKFLOW TAB FUNCTIONS
  // =========================================================================

  // Load task templates
  const loadTemplates = async () => {
    if (!orgId) return;

    setTemplatesLoading(true);
    try {
      const templatesData = await getTemplatesByOrg(orgId);
      console.log("Loaded templates:", templatesData);
      setTemplates(templatesData || []);
    } catch (error) {
      console.error("Error loading templates:", error);
      toast.error("Failed to load task templates");
      setTemplates([]);
    } finally {
      setTemplatesLoading(false);
    }
  };

  // Task Template Handlers
  const handleCreateTemplate = () => {
    setSelectedTemplate(null);
    setShowTemplateModal(true);
  };

  const handleEditTemplate = (template) => {
    setSelectedTemplate(template);
    setShowTemplateModal(true);
  };

  const handleDeleteTemplate = async (templateId) => {
    if (window.confirm("Are you sure you want to delete this template?")) {
      try {
        await deleteTaskTemplate(templateId);
        toast.success("Template deleted successfully");
        loadTemplates();
      } catch (error) {
        console.error("Error deleting template:", error);
        toast.error("Failed to delete template");
      }
    }
  };

  const handleTemplateSaved = () => {
    loadTemplates();
  };

  // =========================================================================
  // PARTNER TAB FUNCTIONS
  // =========================================================================

  // Load partners for the project
  const loadProjectPartners = async () => {
    if (!projectId) return;

    setPartnersLoading(true);
    try {
      const partnersData = await getPartnersByProject(projectId);
      console.log("Loaded project partners:", partnersData);
      setPartners(partnersData || []);
    } catch (error) {
      console.error("Error loading project partners:", error);
      toast.error("Failed to load project partners");
      setPartners([]);
    } finally {
      setPartnersLoading(false);
    }
  };

  // Partner modal handlers
  const handleCreatePartner = () => {
    setEditingPartner(null);
    setShowPartnerModal(true);
  };

  const handleEditPartner = (partner) => {
    setEditingPartner(partner);
    setShowPartnerModal(true);
  };

  const handleClosePartnerModal = () => {
    setShowPartnerModal(false);
    setEditingPartner(null);
  };

  const handlePartnerSaved = () => {
    loadProjectPartners();
    handleClosePartnerModal();
  };

  // =========================================================================
  // COMMERCIALS TAB FUNCTIONS
  // =========================================================================

  // Load commercials for the project
  const loadProjectCommercials = async () => {
    if (!projectId) return;

    setCommercialsLoading(true);
    try {
      const commercialsData = await getCommercialsByProject(projectId);
      console.log("Loaded project commercials:", commercialsData);
      setCommercials(commercialsData || []);
    } catch (error) {
      console.error("Error loading project commercials:", error);
      toast.error("Failed to load project commercials");
      setCommercials([]);
    } finally {
      setCommercialsLoading(false);
    }
  };

  // Commercial modal handlers
  const handleCreateCommercial = () => {
    setEditingCommercial(null);
    setShowCommercialModal(true);
  };

  const handleEditCommercial = (commercial) => {
    setEditingCommercial(commercial);
    setShowCommercialModal(true);
  };

  const handleCloseCommercialModal = () => {
    setShowCommercialModal(false);
    setEditingCommercial(null);
  };

  const handleCommercialSaved = () => {
    loadProjectCommercials();
    handleCloseCommercialModal();
  };

  // =========================================================================
  // MILESTONE TAB FUNCTIONS
  // =========================================================================

  // Function to fetch task details by IDs
  const fetchTaskDetailsByIds = async (taskIds) => {
    if (!taskIds || taskIds.length === 0) return [];

    try {
      const tasksData = await getTasksByProject(projectId);
      console.log("All project tasks:", tasksData);

      // Filter tasks to only include those in the taskIds array
      const filteredTasks = tasksData.filter((task) =>
        taskIds.includes(task.taskId)
      );
      console.log("Filtered tasks for milestone:", filteredTasks);

      return filteredTasks;
    } catch (error) {
      console.error("Error fetching task details:", error);
      return [];
    }
  };

  // Load milestones for the project
  const loadProjectMilestones = async () => {
    if (!projectId || !orgId) return;

    setMilestonesLoading(true);
    try {
      const milestonesData = await getMilestonesByProjectAndOrg(
        projectId,
        orgId
      );
      console.log("Loaded project milestones:", milestonesData);

      // Load tasks for each milestone and calculate percentages
      if (milestonesData && milestonesData.length > 0) {
        const tasksMap = {};
        const updatedMilestones = [];

        // Fetch tasks for each milestone and calculate percentage
        for (const milestone of milestonesData) {
          let taskDetails = [];

          if (
            milestone.taskAssignedList &&
            milestone.taskAssignedList.length > 0
          ) {
            taskDetails = await fetchTaskDetailsByIds(
              milestone.taskAssignedList
            );

            // Calculate percentage based on task status
            const totalTasks = taskDetails.length;
            const completedTasks = taskDetails.filter(
              (task) => task.taskStatus?.toLowerCase() === "completed"
            ).length;

            // Calculate percentage: (completed tasks / total tasks) * 100
            const calculatedPercentage =
              totalTasks > 0
                ? Math.round((completedTasks / totalTasks) * 100)
                : 0;

            // Update milestone with calculated percentage
            const updatedMilestone = {
              ...milestone,
              calculatedPercentage: calculatedPercentage,
              totalTasks: totalTasks,
              completedTasks: completedTasks,
            };

            updatedMilestones.push(updatedMilestone);
          } else {
            // No tasks assigned - percentage is 0
            const updatedMilestone = {
              ...milestone,
              calculatedPercentage: 0,
              totalTasks: 0,
              completedTasks: 0,
            };
            updatedMilestones.push(updatedMilestone);
          }

          tasksMap[milestone.milestoneMavroId] = taskDetails;
        }

        setMilestones(updatedMilestones);
        setMilestoneTasks(tasksMap);
      } else {
        setMilestones(milestonesData || []);
      }
    } catch (error) {
      console.error("Error loading project milestones:", error);
      toast.error("Failed to load project milestones");
      setMilestones([]);
    } finally {
      setMilestonesLoading(false);
    }
  };

  // Milestone modal handlers
  const handleCreateMilestone = () => {
    setEditingMilestone(null);
    setShowMilestoneModal(true);
  };

  const handleEditMilestone = (milestone) => {
    setEditingMilestone(milestone);
    setShowMilestoneModal(true);
  };

  const handleCloseMilestoneModal = () => {
    setShowMilestoneModal(false);
    setEditingMilestone(null);
  };

  const handleMilestoneSaved = () => {
    loadProjectMilestones();
    handleCloseMilestoneModal();
  };

  // Toggle milestone expansion
  const toggleMilestoneExpand = (milestoneId) => {
    setExpandedMilestones((prev) => ({
      ...prev,
      [milestoneId]: !prev[milestoneId],
    }));
  };

  // =========================================================================
  // RESOURCE ALLOCATION TAB FUNCTIONS
  // =========================================================================

  // Load resources for the project
  const loadProjectResources = async () => {
    if (!projectId) return;

    setResourcesLoading(true);
    try {
      const resourcesData = await fetchResourcesByProject(projectId);
      console.log("Loaded project resources:", resourcesData);
      setResources(resourcesData || []);
    } catch (error) {
      console.error("Error loading project resources:", error);
      toast.error("Failed to load project resources");
      setResources([]);
    } finally {
      setResourcesLoading(false);
    }
  };

  // Resource modal handlers
  const handleCreateResource = () => {
    setEditingResource(null);
    setShowResourceModal(true);
  };

  const handleEditResource = (resource) => {
    setEditingResource(resource);
    setShowResourceModal(true);
  };

  const handleCloseResourceModal = () => {
    setShowResourceModal(false);
    setEditingResource(null);
  };

  const handleResourceSaved = () => {
    loadProjectResources();
    handleCloseResourceModal();
    setActiveTab("resourceAllocation");
  };

  // Handle resource deletion
  const handleDeleteResource = async (resourceId) => {
    if (window.confirm("Are you sure you want to delete this resource?")) {
      try {
        await deleteResource(resourceId);
        toast.success("Resource deleted successfully");
        loadProjectResources();
      } catch (error) {
        console.error("Error deleting resource:", error);
        toast.error("Failed to delete resource");
      }
    }
  };

  // Fetch resource details by ID
  const fetchResourceDetails = async (resourceId) => {
    if (!resourceId || resourceDetails[resourceId]) return;

    try {
      setLoadingResourceDetails((prev) => ({
        ...prev,
        [resourceId]: true,
      }));

      const response = await fetchResourceById(resourceId);
      console.log(`Fetched resource details for ${resourceId}:`, response);

      if (response) {
        setResourceDetails((prev) => ({
          ...prev,
          [resourceId]: response,
        }));
      }
    } catch (error) {
      console.error(
        `Error fetching resource details for ${resourceId}:`,
        error
      );
      // Set a fallback object if fetch fails
      setResourceDetails((prev) => ({
        ...prev,
        [resourceId]: { name: resourceId, role: "Unknown" },
      }));
    } finally {
      setLoadingResourceDetails((prev) => ({
        ...prev,
        [resourceId]: false,
      }));
    }
  };

  // =========================================================================
  // DOCUMENTS TAB FUNCTIONS
  // =========================================================================

  // Load documents for the project
  const loadProjectDocuments = async () => {
    if (!projectId) return;

    setDocumentsLoading(true);
    try {
      const documentsData = await getDocumentsByProject(projectId);
      console.log("Loaded project documents:", documentsData);
      setDocuments(documentsData || []);
    } catch (error) {
      console.error("Error loading project documents:", error);
      toast.error("Failed to load project documents");
      setDocuments([]);
    } finally {
      setDocumentsLoading(false);
    }
  };

  // Handle document upload
  // const handleUploadDocuments = async () => {
  //   if (selectedFiles.length === 0) {
  //     toast.error("Please select at least one file to upload");
  //     return;
  //   }

  //   setUploadingDocuments(true);
  //   try {
  //     // Validate files
  //     for (const file of selectedFiles) {
  //       const validation = validateFile(file, 25); // 25MB max size
  //       if (!validation.isValid) {
  //         toast.error(`Invalid file: ${file.name} - ${validation.error}`);
  //         return;
  //       }
  //     }

  //     const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  //     const createdBy = userDetails?.userId || "unknown";

  //     await uploadMultipleProjectDocuments(
  //       orgId,
  //       projectId,
  //       createdBy,
  //       selectedFiles
  //     );

  //     toast.success(
  //       `${selectedFiles.length} document(s) uploaded successfully`
  //     );
  //     setSelectedFiles([]);
  //     setShowUploadModal(false);
  //     loadProjectDocuments(); // Refresh the documents list
  //   } catch (error) {
  //     console.error("Error uploading documents:", error);
  //     toast.error("Failed to upload documents");
  //   } finally {
  //     setUploadingDocuments(false);
  //   }
  // };

  const handleUploadDocuments = async () => {
    if (selectedFiles.length === 0) {
      toast.error("Please select at least one file to upload");
      return;
    }

    if (!documentTitle.trim()) {
      toast.error("Please enter a document title");
      return;
    }

    if (!documentType) {
      toast.error("Please select a document type");
      return;
    }

    setUploadingDocuments(true);
    try {
      // Validate files
      for (const file of selectedFiles) {
        const validation = validateFile(file, 25);
        if (!validation.isValid) {
          toast.error(`Invalid file: ${file.name} - ${validation.error}`);
          return;
        }
      }

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const createdBy = userDetails?.userId || "unknown";

      // Updated API call with title and type
      await uploadMultipleProjectDocuments(
        orgId,
        projectId,
        createdBy,
        selectedFiles,
        documentTitle,
        documentType
      );

      toast.success(
        `${selectedFiles.length} document(s) uploaded successfully`
      );
      setSelectedFiles([]);
      setDocumentTitle("");
      setDocumentType("");
      setShowUploadModal(false);
      loadProjectDocuments();
    } catch (error) {
      console.error("Error uploading documents:", error);
      toast.error("Failed to upload documents");
    } finally {
      setUploadingDocuments(false);
    }
  };

  const getFileNameFromHeaders = (headers, fallback = "download") => {
    const cd = headers["content-disposition"] || headers["Content-Disposition"];
    if (!cd) return fallback;

    // Example: attachment; filename="file.xlsx"; filename*=UTF-8''file.xlsx
    const filenameStarMatch = cd.match(/filename\*\=([^;]+)/i);
    if (filenameStarMatch) {
      try {
        const value = filenameStarMatch[1].trim(); // UTF-8''name
        const idx = value.indexOf("''");
        if (idx !== -1) {
          return decodeURIComponent(value.substring(idx + 2));
        }
        return decodeURIComponent(value.replace(/^UTF-8''/i, ""));
      } catch (_) {
        /* ignore decode errors */
      }
    }

    const filenameMatch = cd.match(/filename\=\"?([^\";]+)\"?/i);
    if (filenameMatch) return filenameMatch[1];

    return fallback;
  };

  // Handle document download
  // Handle document download
  const handleDownloadDocument = async (doc) => {
    try {
      toast.info("Downloading document...");

      // If you have a utility that already does this correctly, keep it.
      // Otherwise, do the robust approach below:
      const response = await downloadDocument(doc.documentId);

      // 1) Extract filename from headers, fallback to title, keep extension if any
      const serverFileName = getFileNameFromHeaders(
        response.headers,
        doc.documentTitle || "document"
      );
      // 2) Use the server content-type to create a proper Blob
      const contentType =
        response.headers["content-type"] ||
        response.headers["Content-Type"] ||
        "application/octet-stream";

      const blob = new Blob([response.data], { type: contentType });

      // 3) Create link and trigger download
      const url = window.URL.createObjectURL(blob);
      const a = window.document.createElement("a"); // IMPORTANT: window.document (not the param)
      a.href = url;
      a.download = serverFileName;
      window.document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Document downloaded successfully");
    } catch (error) {
      console.error("Error downloading document:", error);
      toast.error("Failed to download document. Please try again.");
    }
  };

  // Handle document deletion
  const handleDeleteDocument = async (documentId, documentTitle) => {
    if (window.confirm(`Are you sure you want to delete "${documentTitle}"?`)) {
      try {
        await deleteDocumentWithFile(documentId);
        toast.success("Document deleted successfully");
        loadProjectDocuments(); // Refresh the documents list
      } catch (error) {
        console.error("Error deleting document:", error);
        toast.error("Failed to delete document");
      }
    }
  };

  // Handle file selection
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
  };

  // =========================================================================
  // HELPER FUNCTIONS
  // =========================================================================

  // Helper function to get status description by ID
  const getStatusDescription = (statusId) => {
    if (!statusId) return "Not set";
    const status = projectStatuses.find((s) => s.projectStatusId === statusId);
    return status ? status.projectStatusDesc : statusId;
  };

  // Helper function to get resource name by ID
  const getResourceNameById = (resourceId) => {
    if (!resourceId) return "Not assigned";
    const resource = resourcesByOrg.find(
      (res) => res.resourceId === resourceId
    );
    return resource ? resource.name : resourceId;
  };

  // Helper function to get user display info
  const getUserDisplayInfo = (userId) => {
    const userDetail = teamMemberDetails.find(
      (user) => user.userId === parseInt(userId)
    );
    if (userDetail) {
      console.log("User Detail Found:", userDetail);
      return {
        name: userDetail.username,
        email: userDetail.email,
      };
    }
    return {
      name: "Unknown User",
      email: "No email",
      role: "Team Member",
    };
  };

  // Helper function to parse partner roles from JSON
  const parsePartnerRoles = (partnerRole) => {
    try {
      if (typeof partnerRole === "string") {
        return JSON.parse(partnerRole);
      }
      return partnerRole || [];
    } catch (error) {
      console.error("Error parsing partner roles:", error);
      return [];
    }
  };

  // Helper function to format roles for display
  const formatRoles = (roles) => {
    if (Array.isArray(roles)) {
      return roles.join(", ");
    }
    return roles || "No roles assigned";
  };

  // Helper function to get field display name
  const getFieldDisplayName = (fieldName) => {
    const fieldConfig = availableFields.find((f) => f.field === fieldName);
    return fieldConfig?.displayName || fieldName;
  };

  // Format currency for display
  const formatCurrencyDisplay = (amount, currency) => {
    if (!amount) return "-";

    const numericAmount = parseFloat(amount);
    if (isNaN(numericAmount)) return amount;

    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 2,
    });

    return formatter.format(numericAmount);
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("MMM DD, YYYY");
  };

  // Format datetime for display
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("MMM DD, YYYY HH:mm");
  };

  // Status badge helpers
  const getStatusBadge = (statusId) => {
    // Get the status description first
    const statusDesc = getStatusDescription(statusId);

    const statusMap = {
      // Status descriptions
      Idea: "status-pending",
      Discussion: "status-pending",
      Proposal: "status-pending",
      Dev: "status-active",
      SIT: "status-active",
      UAT: "status-active",
      "Go-Live": "status-active",
      Hypercare: "status-active",
      Closed: "status-completed",
      Cancelled: "status-pending",

      // Legacy status mappings (keep for backward compatibility)
      Active: "status-active",
      Completed: "status-completed",
      Pending: "status-pending",
      "In Progress": "status-active",
      open: "status-active",
      closed: "status-completed",
      resolved: "status-completed",
      "in progress": "status-active",
    };

    return statusMap[statusDesc] || "status-pending";
  };

  const getPriorityBadge = (priority) => {
    const priorityMap = {
      High: "priority-high",
      Medium: "priority-medium",
      Low: "priority-low",
      high: "priority-high",
      medium: "priority-medium",
      low: "priority-low",
    };
    return priorityMap[priority] || "priority-medium";
  };

  // Helper function for resource status badges
  const getResourceStatusBadge = (status) => {
    const statusMap = {
      Active: "bg-success",
      "In Progress": "bg-primary",
      Completed: "bg-secondary",
      "On Hold": "bg-warning",
      Inactive: "bg-danger",
    };
    return statusMap[status] || "bg-secondary";
  };

  // =========================================================================
  // USE EFFECT HOOKS
  // =========================================================================

  // INITIAL LOAD EFFECTS
  useEffect(() => {
    loadProjectDetails();
  }, [projectId]);

  useEffect(() => {
    loadProjectStatuses();
  }, []);

  useEffect(() => {
    if (orgId) {
      loadCustomers();
      loadTeams();
      fetchProjectTypesList();
      loadResourcesByOrg();
    }
  }, [orgId]);

  // OVERVIEW TAB EFFECTS
  useEffect(() => {
    if (project?.prTypes) {
      fetchProjectTypeDescription(project.prTypes);
    }
  }, [project?.prTypes]);

  useEffect(() => {
    if (project?.prClient && customers.length > 0) {
      const customer = customers.find(
        (cust) => cust.customerCode === project.prClient
      );
      if (customer) {
        setSelectedCustomerName(customer.name);
      } else {
        setSelectedCustomerName(project.prClient);
      }
    } else if (project?.prClient) {
      setSelectedCustomerName(project.prClient);
    } else {
      setSelectedCustomerName("");
    }
  }, [project?.prClient, customers]);

  useEffect(() => {
    if (project) {
      // Fetch project manager name
      if (project.currentProjectManager) {
        fetchProjectManagerName(project.currentProjectManager);
      } else {
        setProjectManagerName("Not assigned");
      }

      // Fetch salesperson name
      if (project.salespersonCode) {
        fetchSalespersonName(project.salespersonCode);
      } else {
        setSalespersonName("Not assigned");
      }
    }
  }, [project]);

  useEffect(() => {
    const fetchTeamData = async () => {
      console.log("inside fetch team data useEffect");
      console.log("project.teamAssigned:", project?.teamAssigned);

      if (project?.teamAssigned) {
        try {
          const teamData = await getTeamById(project.teamAssigned);
          console.log("Fetched team data:", teamData);
          setTeamData(teamData);

          // Fetch user details for team members
          if (teamData.teamMembers && teamData.teamMembers.length > 0) {
            await fetchTeamMemberDetails(teamData.teamMembers);
          } else {
            setTeamMemberDetails([]);
          }
        } catch (error) {
          console.error("Error fetching team data:", error);
          setTeamData(null);
          setTeamMemberDetails([]);
        }
      } else {
        console.log("No teamAssigned found in project data");
        setTeamData(null);
        setTeamMemberDetails([]);
      }
    };

    fetchTeamData();
  }, [project?.teamAssigned]);

  // TASKS TAB EFFECTS
  // TASKS TAB EFFECTS
  useEffect(() => {
    if (activeTab === "tasks" && project?.projectId) {
      loadProjectStages(); // Always load stages when on tasks tab
    }
  }, [activeTab, project?.projectId]);

  useEffect(() => {
    if (activeTab === "tasks" && project?.projectId) {
      if (stages.length > 0) {
        loadProjectTasksByStages();
      } else {
        // If no stages exist, load tasks directly
        loadProjectTasks();
      }
    }
  }, [activeTab, stages, project?.projectId]);

  // TICKET TAB EFFECTS
  useEffect(() => {
    if (activeTab === "ticket" && project?.projectId) {
      loadProjectTickets();
    }
  }, [activeTab, project?.projectId]);

  // WORKFLOW TAB EFFECTS
  useEffect(() => {
    if (activeTab === "workflow" && orgId) {
      loadTemplates();
    }
  }, [activeTab, orgId]);

  // PARTNER TAB EFFECTS
  useEffect(() => {
    if (activeTab === "partner" && orgId && projectId) {
      loadProjectPartners();
    }
  }, [activeTab, orgId, projectId]);

  // COMMERCIALS TAB EFFECTS
  useEffect(() => {
    if (activeTab === "commercials" && projectId) {
      loadProjectCommercials();
    }
  }, [activeTab, projectId]);

  // MILESTONE TAB EFFECTS
  useEffect(() => {
    if (activeTab === "milestone" && projectId && orgId) {
      loadProjectMilestones();
    }
  }, [activeTab, projectId, orgId]);

  // RESOURCE ALLOCATION TAB EFFECTS
  useEffect(() => {
    if (activeTab === "resourceAllocation" && projectId) {
      loadProjectResources();
    }
  }, [activeTab, projectId]);

  // DOCUMENTS TAB EFFECTS
  useEffect(() => {
    if (activeTab === "documents" && projectId) {
      loadProjectDocuments();
    }
  }, [activeTab, projectId]);

  // =========================================================================
  // RENDER COMPONENTS
  // =========================================================================

  // Milestone Tasks Component
  const MilestoneTasks = ({ tasks, milestoneId }) => {
    if (!tasks || tasks.length === 0) {
      return (
        <div className="text-center py-3 text-muted">
          <small>No tasks assigned to this milestone</small>
        </div>
      );
    }

    return (
      <div className="milestone-tasks-container">
        <div className="milestone-tasks-list">
          {tasks.map((task) => (
            <div key={task.taskId} className="milestone-task-item">
              <div className="milestone-task-main">
                <div className="milestone-task-name">
                  <strong>{task.taskName}</strong>
                </div>
                <div className="milestone-task-meta">
                  <span
                    className={`task-status-badge ${getStatusBadge(
                      task.taskStatus
                    )}`}
                  >
                    {task.taskStatus}
                  </span>
                  <span
                    className={`task-priority-badge ${getPriorityBadge(
                      task.taskPriority
                    )}`}
                  >
                    {task.taskPriority}
                  </span>
                </div>
              </div>
              <div className="milestone-task-details">
                <small className="text-muted">
                  {task.taskDescription
                    ? task.taskDescription.length > 100
                      ? `${task.taskDescription.substring(0, 100)}...`
                      : task.taskDescription
                    : "No description"}
                </small>
              </div>
              <div className="milestone-task-dates">
                <small>
                  Start: {formatDate(task.taskStartDate)} | End:{" "}
                  {formatDate(task.taskEndDate)}
                </small>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Loading and Error States
  if (loading) {
    return (
      <div className="project-view-container">
        <Container>
          <div className="text-center text-white">
            <h3>Loading Project Details...</h3>
          </div>
        </Container>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="project-view-container">
        <Container>
          <div className="text-center text-white">
            <h3>Project Not Found</h3>
            <Button variant="light" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="project-view-container">
      <Container fluid>
        {/* Project Header */}
        <div className="project-view-card fade-in">
          <div className="project-view-header">
            <div className="d-flex justify-content-between align-items-start mb-3">
              <Button
                variant="outline-light"
                size="sm"
                onClick={() => navigate("/viewProjects")}
              >
                ← Back to Projects
              </Button>

              <Button
                variant={project?.isFavourite ? "danger" : "outline-light"}
                size="sm"
                onClick={handleToggleFavorite}
                className="me-2 d-flex align-items-center"
                title={
                  project?.isFavourite
                    ? "Remove from favorites"
                    : "Add to favorites"
                }
              >
                {project?.isFavourite ? (
                  <FaHeart
                    style={{
                      animation: "heartbeat 1s infinite",
                      marginRight: "4px",
                      fontSize: "15px",
                    }}
                  />
                ) : (
                  <CiHeart style={{ marginRight: "4px", fontSize: "30px" }} />
                )}
                {/* <span>{project?.isFavourite ? "Favorited" : "Favorite"}</span> */}
              </Button>

              {isEditing && (
                <div className="edit-controls">
                  <Button
                    variant="success"
                    size="sm"
                    onClick={handleSave}
                    disabled={saving}
                    className="me-2"
                  >
                    {saving ? "Saving..." : "Save Changes"}
                  </Button>
                  <Button
                    variant="outline-light"
                    size="sm"
                    onClick={handleCancel}
                    disabled={saving}
                  >
                    Cancel
                  </Button>
                </div>
              )}
            </div>

            {/* Editable Project Title */}
            {isEditing ? (
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  value={project.prTitle || ""}
                  onChange={(e) => handleFieldChange("prTitle", e.target.value)}
                  className="project-title-edit"
                  placeholder="Project Title"
                />
              </Form.Group>
            ) : (
              <h1
                className="project-view-title editable-field"
                onClick={() => setIsEditing(true)}
                title="Click to edit"
              >
                {project.prTitle}
              </h1>
            )}

            {/* Editable Project Description */}
            {isEditing ? (
              <Form.Group className="mb-3">
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={project.prDescription || ""}
                  onChange={(e) =>
                    handleFieldChange("prDescription", e.target.value)
                  }
                  className="project-subtitle-edit"
                  placeholder="Project Description"
                />
              </Form.Group>
            ) : (
              <p
                className="project-view-subtitle editable-field"
                onClick={() => setIsEditing(true)}
                title="Click to edit"
              >
                {project.prDescription}
              </p>
            )}

            <div className="project-view-meta">
              <div className="project-meta-item">
                <i className="fas fa-calendar"></i>
                <span>
                  {moment(project.prStartDate).format("MMM DD, YYYY")} -{" "}
                  {moment(project.prEndDate).format("MMM DD, YYYY")}
                </span>
              </div>
              {/* <div className="project-meta-item">
                <i className="fas fa-user"></i>
                <span>{project.currentProjectManager}</span>
              </div> */}
              <div className="" style={{ marginTop: "9px" }}>
                <span
                  className={`project-status-badge ${getStatusBadge(
                    project.projectStatus
                  )}`}
                >
                  {getStatusDescription(project.projectStatus)}
                </span>
              </div>
              <div className="project-meta-item">
                <i className="fas fa-users"></i>
                <span>
                  {teamData?.teamName ||
                    project.teamAssigned ||
                    "No team assigned"}
                </span>
              </div>
            </div>
          </div>

          {/* Tabs Navigation */}
          <div className="project-view-tabs">
            <ul className="project-tab-nav">
              <li
                className={`project-tab-item ${
                  activeTab === "overview" ? "active" : ""
                }`}
                onClick={() => setActiveTab("overview")}
              >
                <i className="fas fa-chart-pie me-2"></i>
                Overview
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "tasks" ? "active" : ""
                }`}
                onClick={() => setActiveTab("tasks")}
              >
                Task List
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "team" ? "active" : ""
                }`}
                onClick={() => setActiveTab("team")}
              >
                Team
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "ticket" ? "active" : ""
                }`}
                onClick={() => setActiveTab("ticket")}
              >
                Ticket
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "resourceAllocation" ? "active" : ""
                }`}
                onClick={() => setActiveTab("resourceAllocation")}
              >
                Resource Allocation
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "commercials" ? "active" : ""
                }`}
                onClick={() => setActiveTab("commercials")}
              >
                Commercials
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "workflow" ? "active" : ""
                }`}
                onClick={() => setActiveTab("workflow")}
              >
                Workflow
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "partner" ? "active" : ""
                }`}
                onClick={() => setActiveTab("partner")}
              >
                Partner
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "milestone" ? "active" : ""
                }`}
                onClick={() => setActiveTab("milestone")}
              >
                Milestone
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => setActiveTab("documents")}
              >
                Documents
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "budget" ? "active" : ""
                }`}
                onClick={() => setActiveTab("budget")}
              >
                Budget
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "settings" ? "active" : ""
                }`}
                onClick={() => setActiveTab("settings")}
              >
                Settings
              </li>
            </ul>
          </div>

          {/* Tab Content */}
          <div className="project-tab-content">
            {activeTab === "overview" && (
              <div className="fade-in">
                <div className="project-overview-single-card">
                  {/* <h3 className="overview-section-title">Project Details</h3> */}
                  <div className="overview-grid">
                    <div className="overview-row">
                      <span className="overview-label">Project ID:</span>
                      <span className="overview-value">
                        {project.projectId}
                      </span>
                      <span className="overview-label">Client:</span>
                      {isEditing ? (
                        customersLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading customers...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.prClient || ""}
                            onChange={(e) =>
                              handleCustomerChange(e.target.value)
                            }
                            size="sm"
                            className="editable-input"
                          >
                            <option value="">Select a client</option>
                            {customers.map((customer) => (
                              <option
                                key={customer.customerCode}
                                value={customer.customerCode}
                              >
                                {customer.name} ({customer.customerCode})
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span
                          className="overview-value editable-field"
                          onClick={() => setIsEditing(true)}
                          title="Click to edit"
                        >
                          {selectedCustomerName ||
                            project.prClient ||
                            "Not selected"}
                        </span>
                      )}
                    </div>

                    <div className="overview-row">
                      <span className="overview-label">Project Type:</span>
                      {isEditing ? (
                        projectTypeLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading project types...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.prTypes || ""}
                            onChange={(e) => {
                              const selectedProjectTypeId = e.target.value;
                              handleFieldChange(
                                "prTypes",
                                selectedProjectTypeId
                              );

                              // Update description immediately for better UX
                              const selectedProjectType = projectTypes.find(
                                (type) =>
                                  type.projectTypeId === selectedProjectTypeId
                              );
                              if (selectedProjectType) {
                                setProjectTypeDesc(
                                  selectedProjectType.projectTypeDesc
                                );
                              }
                            }}
                            size="sm"
                            className="editable-input"
                          >
                            <option value="">Select Project Type</option>
                            {projectTypes.map((type) => (
                              <option
                                key={type.projectTypeId}
                                value={type.projectTypeId}
                              >
                                {type.projectTypeDesc} ({type.projectTypeId})
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span
                          className="overview-value editable-field"
                          onClick={() => setIsEditing(true)}
                          title="Click to edit"
                        >
                          {projectTypeDesc || project.prTypes || "Not selected"}
                        </span>
                      )}
                      <span className="overview-label">Category:</span>
                      {isEditing ? (
                        <Form.Control
                          type="text"
                          value={project.projectCategory || ""}
                          onChange={(e) =>
                            handleFieldChange("projectCategory", e.target.value)
                          }
                          size="sm"
                          className="editable-input"
                        />
                      ) : (
                        <span
                          className="overview-value editable-field"
                          onClick={() => setIsEditing(true)}
                          title="Click to edit"
                        >
                          {project.projectCategory || "-"}
                        </span>
                      )}
                    </div>

                    <div className="overview-row">
                      <span className="overview-label">Tags:</span>
                      {isEditing ? (
                        <Form.Control
                          type="text"
                          value={project.prTags || ""}
                          onChange={(e) =>
                            handleFieldChange("prTags", e.target.value)
                          }
                          size="sm"
                          className="editable-input"
                          placeholder="Comma separated tags"
                        />
                      ) : (
                        <span className="overview-value">
                          {project.prTags
                            ? project.prTags.split(",").map((tag) => (
                                <Badge
                                  key={tag}
                                  bg="secondary"
                                  className="me-1"
                                >
                                  {tag.trim()}
                                </Badge>
                              ))
                            : "No tags"}
                        </span>
                      )}

                      <span className="overview-label">Priority</span>
                      {isEditing ? (
                        <Form.Select
                          value={project.projectPriority || ""}
                          onChange={(e) =>
                            handleFieldChange("projectPriority", e.target.value)
                          }
                          size="sm"
                          className="editable-input"
                          required
                        >
                          <option value="">Select Priority</option>
                          <option value="Very High">Very High</option>
                          <option value="High">High</option>
                          <option value="Medium">Medium</option>
                          <option value="Low">Low</option>
                        </Form.Select>
                      ) : (
                        <span className="overview-value">
                          {project.projectPriority ? (
                            <Badge bg="secondary" className="me-1">
                              {project.projectPriority}
                            </Badge>
                          ) : (
                            "No Priority"
                          )}
                        </span>
                      )}
                    </div>
                  </div>

                  <h3 className="overview-section-title mt-4">Timeline</h3>
                  <div className="overview-grid">
                    <div className="overview-row">
                      <span className="overview-label">Start Date:</span>
                      {isEditing ? (
                        <Form.Control
                          type="date"
                          value={
                            project.prStartDate
                              ? moment(project.prStartDate).format("YYYY-MM-DD")
                              : ""
                          }
                          onChange={(e) =>
                            handleFieldChange("prStartDate", e.target.value)
                          }
                          size="sm"
                          className="editable-input"
                        />
                      ) : (
                        <span className="overview-value">
                          {moment(project.prStartDate).format("MMMM DD, YYYY")}
                        </span>
                      )}
                      <span className="overview-label">End Date:</span>
                      {isEditing ? (
                        <Form.Control
                          type="date"
                          value={
                            project.prEndDate
                              ? moment(project.prEndDate).format("YYYY-MM-DD")
                              : ""
                          }
                          onChange={(e) =>
                            handleFieldChange("prEndDate", e.target.value)
                          }
                          size="sm"
                          className="editable-input"
                        />
                      ) : (
                        <span className="overview-value">
                          {moment(project.prEndDate).format("MMMM DD, YYYY")}
                        </span>
                      )}
                    </div>
                    <div className="overview-row">
                      <span className="overview-label">Duration:</span>
                      <span className="overview-value">
                        {moment(project.prEndDate).diff(
                          moment(project.prStartDate),
                          "days"
                        )}{" "}
                        days
                      </span>
                      <span className="overview-label">Days Remaining:</span>
                      <span className="overview-value">
                        {Math.max(
                          0,
                          moment(project.prEndDate).diff(moment(), "days")
                        )}{" "}
                        days
                      </span>
                    </div>
                  </div>

                  <h3 className="overview-section-title mt-4">
                    Team & Contact
                  </h3>
                  <div className="overview-grid">
                    <div className="overview-row">
                      <span className="overview-label">Project Manager:</span>
                      {isEditing ? (
                        resourcesByOrgLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading resources...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.currentProjectManager || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                "currentProjectManager",
                                e.target.value
                              )
                            }
                            size="sm"
                            className="editable-input"
                          >
                            <option value="">Select Project Manager</option>
                            {resourcesByOrg.map((resource) => (
                              <option
                                key={resource.resourceId}
                                value={resource.resourceId}
                              >
                                {resource.name} ({resource.resourceId})
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span
                          className="overview-value editable-field"
                          onClick={() => setIsEditing(true)}
                          title="Click to edit"
                        >
                          {loadingManager ? (
                            <div className="d-flex align-items-center">
                              <div
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                              Loading...
                            </div>
                          ) : (
                            getResourceNameById(
                              project.currentProjectManager
                            ) || "Not assigned"
                          )}
                        </span>
                      )}
                      <span className="overview-label">Team Assigned:</span>
                      {isEditing ? (
                        <Form.Select
                          value={project.teamId || ""}
                          onChange={(e) => {
                            const selectedTeamId = e.target.value;
                            const selectedTeam = teams.find(
                              (team) => team.teamId === selectedTeamId
                            );
                            setSelectedTeamId(selectedTeamId);
                            handleFieldChange("teamId", selectedTeamId);
                            handleFieldChange(
                              "teamAssigned",
                              selectedTeam ? selectedTeam.teamName : ""
                            );
                          }}
                          size="sm"
                          className="editable-input"
                        >
                          <option value="">Select a team</option>
                          {teams.map((team) => (
                            <option key={team.teamId} value={team.teamId}>
                              {team.teamName}
                            </option>
                          ))}
                        </Form.Select>
                      ) : (
                        <span
                          className="overview-value editable-field"
                          onClick={() => setIsEditing(true)}
                          title="Click to edit"
                        >
                          {teamData?.teamName ||
                            project.teamAssigned ||
                            "Not assigned"}
                        </span>
                      )}
                    </div>
                    <div className="overview-row">
                      <span className="overview-label">Salesperson:</span>
                      {isEditing ? (
                        resourcesByOrgLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading resources...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.salespersonCode || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                "salespersonCode",
                                e.target.value
                              )
                            }
                            size="sm"
                            className="editable-input"
                          >
                            <option value="">Select Salesperson</option>
                            {resourcesByOrg.map((resource) => (
                              <option
                                key={resource.resourceId}
                                value={resource.resourceId}
                              >
                                {resource.name} ({resource.resourceId})
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span
                          className="overview-value editable-field"
                          onClick={() => setIsEditing(true)}
                          title="Click to edit"
                        >
                          {loadingSalesperson ? (
                            <div className="d-flex align-items-center">
                              <div
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                              Loading...
                            </div>
                          ) : (
                            getResourceNameById(project.salespersonCode) ||
                            "Not assigned"
                          )}
                        </span>
                      )}
                      <span className="overview-label">Status:</span>
                      {isEditing ? (
                        projectStatusesLoading ? (
                          <div className="d-flex align-items-center">
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                            <small className="text-muted">
                              Loading statuses...
                            </small>
                          </div>
                        ) : (
                          <Form.Select
                            value={project.projectStatus || ""}
                            onChange={(e) =>
                              handleFieldChange("projectStatus", e.target.value)
                            }
                            size="sm"
                            className="editable-input"
                          >
                            <option value="">Select Status</option>
                            {projectStatuses.map((status) => (
                              <option
                                key={status.projectStatusId}
                                value={status.projectStatusId}
                              >
                                {status.projectStatusDesc}
                              </option>
                            ))}
                          </Form.Select>
                        )
                      ) : (
                        <span className="overview-value">
                          <span
                            className={`project-status-badge ${getStatusBadge(
                              project.projectStatus
                            )}`}
                          >
                            {getStatusDescription(project.projectStatus)}
                          </span>
                        </span>
                      )}
                    </div>
                  </div>

                  <h3 className="overview-section-title mt-4">
                    Additional Info
                  </h3>
                  <div className="overview-grid">
                    <div className="overview-row">
                      <span className="overview-label">Comments:</span>
                      {isEditing ? (
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={project.comments || ""}
                          onChange={(e) =>
                            handleFieldChange("comments", e.target.value)
                          }
                          className="editable-input"
                          placeholder="Add comments..."
                        />
                      ) : (
                        <span
                          className="overview-value editable-field"
                          onClick={() => setIsEditing(true)}
                          title="Click to edit"
                        >
                          {project.comments || "No comments"}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "tasks" && (
              <div className="fade-in">
                <div className="task-list-container">
                  <div className="task-list-header">
                    <div className="task-list-filters d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <div className="dropdown">
                          <Button
                            size="sm"
                            onClick={handleAddTaskClick}
                            className="me-2"
                          >
                            Add Task
                          </Button>

                          {showTaskOptions && (
                            <div className="task-options-dropdown">
                              <div className="task-options-content">
                                <div
                                  className="task-option-item"
                                  onClick={handleExcelUploadClick}
                                >
                                  <i className="fas fa-file-excel me-2 text-success"></i>
                                  <span>Task by Excel Upload</span>
                                </div>
                                <div
                                  className="task-option-item"
                                  onClick={handleManualTaskClick}
                                >
                                  <i className="fas fa-user-plus me-2 text-primary"></i>
                                  <span>Task by User</span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        <Button size="sm" onClick={handleCreateStage}>
                          Add Stage
                        </Button>
                      </div>

                      {/* 🔍 Search Input */}
                      {/* 🔍 Search Input + Reset Button */}
                      <div className="search-box ms-3 d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control form-control-sm me-2"
                          placeholder="Search tasks by name..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          style={{ width: "220px" }}
                        />

                        {searchQuery && (
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => setSearchQuery("")}
                            title="Reset search"
                          >
                            <i className="fas fa-times"></i> Reset
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>

                  {tasksLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading tasks...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="stages-tabular-container">
                      {/* Render stages with tasks */}
                      {stages.map((stage) => (
                        <div key={stage.stageId} className="stage-section">
                          {/* Stage Header */}
                          <div className="stage-section-header">
                            <div className="stage-info">
                              <h4 className="stage-title">{stage.stageName}</h4>
                            </div>
                            <div className="stage-meta">
                              <Badge
                                bg="secondary"
                                className="task-count-badge"
                              >
                                {
                                  (filteredStageTasks[stage.stageId] || [])
                                    .length
                                }{" "}
                                tasks
                              </Badge>
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleEditStage(stage)}
                                className="ms-2"
                                title="Edit Stage"
                              >
                                <i className="fas fa-edit"></i> Edit Stage
                              </Button>
                            </div>
                          </div>

                          {/* Tasks Table for this Stage */}
                          <div className="stage-tasks-table">
                            {tasksLoadingByStage[stage.stageId] ? (
                              <div className="text-center py-3">
                                <div
                                  className="spinner-border spinner-border-sm text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading tasks...
                                  </span>
                                </div>
                              </div>
                            ) : filteredStageTasks[stage.stageId]?.length >
                              0 ? (
                              <div className="table-responsive">
                                <table className="task-table">
                                  <thead className="task-table-header">
                                    <tr>
                                      <th>TaskId</th>
                                      <th>Task Name</th>
                                      <th>Description</th>
                                      <th>Assigned To</th>
                                      <th>Priority</th>
                                      <th>Status</th>
                                      <th>Start Date</th>
                                      <th>End Date</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody className="task-table-body">
                                    {filteredStageTasks[stage.stageId].map(
                                      (task) => (
                                        <tr
                                          key={task.taskId}
                                          className="task-table-row"
                                        >
                                          <td>{task.taskId}</td>
                                          <td className="task-name-cell">
                                            <div
                                              className="task-name clickable-task-name"
                                              onClick={() =>
                                                handleTaskNameClick(task.taskId)
                                              }
                                              title="Click to view task details"
                                            >
                                              {task.taskName}
                                            </div>
                                          </td>
                                          <td className="task-description-cell">
                                            <div className="task-description">
                                              {task.taskDescription || "-"}
                                            </div>
                                          </td>
                                          <td className="task-assigned-cell">
                                            <div className="task-assigned d-flex flex-column gap-1">
                                              {/* Show multiple assignments */}
                                              {(() => {
                                                const currentAssignments =
                                                  getCurrentAssignedUsersForTask(
                                                    task.taskId
                                                  );

                                                if (
                                                  currentAssignments.length ===
                                                  0
                                                ) {
                                                  return (
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <span className="text-muted">
                                                        Unassigned
                                                      </span>
                                                      <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() =>
                                                          openTaskDialog(task)
                                                        }
                                                        className="ms-2"
                                                        title="Manage Assignments"
                                                      >
                                                        Assign
                                                      </Button>
                                                    </div>
                                                  );
                                                }

                                                return (
                                                  <>
                                                    {currentAssignments.map(
                                                      (assignment, index) => {
                                                        const userDetail =
                                                          teamMemberDetails.find(
                                                            (user) =>
                                                              String(
                                                                user.userId
                                                              ) ===
                                                              String(
                                                                assignment.assignedUserId
                                                              )
                                                          );
                                                        const userName =
                                                          userDetail?.username ||
                                                          assignment.assignedUserId;

                                                        return (
                                                          <div
                                                            key={
                                                              assignment.assignmentId ||
                                                              index
                                                            }
                                                            className="d-flex align-items-center justify-content-between"
                                                          >
                                                            <div className="d-flex align-items-center">
                                                              <span className="me-2">
                                                                {userName}
                                                              </span>
                                                              <Badge
                                                                bg={
                                                                  assignment.isActive
                                                                    ? "success"
                                                                    : "secondary"
                                                                }
                                                                size="sm"
                                                                className="assignment-status-badge"
                                                              >
                                                                {assignment.isActive
                                                                  ? "Active"
                                                                  : "Completed"}
                                                              </Badge>
                                                              {assignment.totalHours && (
                                                                <small className="ms-2 text-muted">
                                                                  (
                                                                  {parseFloat(
                                                                    assignment.totalHours
                                                                  ).toFixed(2)}
                                                                  h)
                                                                </small>
                                                              )}
                                                            </div>
                                                            {index === 0 && ( // Only show assign button on first item
                                                              <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                onClick={() =>
                                                                  openTaskDialog(
                                                                    task
                                                                  )
                                                                }
                                                                className="ms-2"
                                                                title="Manage Assignments"
                                                              >
                                                                Manage
                                                              </Button>
                                                            )}
                                                          </div>
                                                        );
                                                      }
                                                    )}

                                                    {/* Show count if there are more assignments */}
                                                    {taskAssignmentsByTask[
                                                      task.taskId
                                                    ]?.length >
                                                      currentAssignments.length && (
                                                      <small className="text-muted">
                                                        +
                                                        {taskAssignmentsByTask[
                                                          task.taskId
                                                        ].length -
                                                          currentAssignments.length}{" "}
                                                        more assignments
                                                      </small>
                                                    )}
                                                  </>
                                                );
                                              })()}
                                            </div>
                                          </td>
                                          <td className="task-priority-cell">
                                            <span
                                              className={`task-priority-badge ${getPriorityBadge(
                                                task.taskPriority
                                              )}`}
                                            >
                                              {task.taskPriority ||
                                                "No Priority"}
                                            </span>
                                          </td>
                                          <td className="task-status-cell">
                                            <span
                                              className={`task-status-badge ${getStatusBadge(
                                                task.taskStatus
                                              )}`}
                                            >
                                              {task.taskStatus || "No Status"}
                                            </span>
                                          </td>
                                          <td className="task-date-cell">
                                            {moment(task.taskStartDate).format(
                                              "MMM DD, YYYY"
                                            )}
                                          </td>
                                          <td className="task-date-cell">
                                            {moment(task.taskEndDate).format(
                                              "MMM DD, YYYY"
                                            )}
                                          </td>
                                          <td className="task-actions-cell">
                                            <div className="task-actions">
                                              <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() =>
                                                  handleEditTask(task.taskId)
                                                }
                                                className="me-2"
                                                title="Edit Task"
                                              >
                                                Edit
                                              </Button>
                                              <Button
                                                variant="outline-danger"
                                                size="sm"
                                                title="Delete Task"
                                              >
                                                Delete
                                              </Button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              <div className="text-center py-4 text-muted">
                                <i className="fas fa-tasks fa-2x mb-3"></i>
                                <p>No tasks found in this stage.</p>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}

                      {/* Render "No Stage" section if there are tasks without stage */}
                      {/* Render "No Stage" section if there are tasks without stage */}
                      {filteredStageTasks["no-stage"]?.length > 0 && (
                        <div
                          key="no-stage"
                          className="stage-section no-stage-section"
                        >
                          {/* No Stage Header */}
                          <div className="stage-section-header no-stage-header">
                            <div className="stage-info">
                              <h4
                                className="stage-title"
                                style={{ padding: "10px" }}
                              >
                                <i className="fas fa-question-circle me-2 text-warning"></i>
                                No Stage Assigned
                              </h4>
                            </div>
                            <div className="stage-meta">
                              <Badge bg="warning" className="task-count-badge">
                                {filteredStageTasks["no-stage"].length} tasks
                              </Badge>
                            </div>
                          </div>

                          {/* Tasks Table for No Stage */}
                          <div className="stage-tasks-table">
                            {tasksLoadingByStage["no-stage"] ? (
                              <div className="text-center py-3">
                                <div
                                  className="spinner-border spinner-border-sm text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading tasks...
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div className="table-responsive">
                                <table className="task-table">
                                  <thead className="task-table-header">
                                    <tr>
                                      <th>TaskId</th>
                                      <th>Task Name</th>
                                      <th>Description</th>
                                      <th>Assigned To</th>
                                      <th>Priority</th>
                                      <th>Status</th>
                                      <th>Start Date</th>
                                      <th>End Date</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody className="task-table-body">
                                    {filteredStageTasks["no-stage"].map(
                                      (task) => (
                                        <tr
                                          key={task.taskId}
                                          className="task-table-row"
                                        >
                                          <td>{task.taskId}</td>
                                          <td className="task-name-cell">
                                            <div
                                              className="task-name clickable-task-name"
                                              onClick={() =>
                                                handleTaskNameClick(task.taskId)
                                              }
                                              title="Click to view task details"
                                            >
                                              {task.taskName}
                                            </div>
                                          </td>
                                          <td className="task-description-cell">
                                            <div className="task-description">
                                              {task.taskDescription || "-"}
                                            </div>
                                          </td>
                                          <td className="task-assigned-cell">
                                            <div className="task-assigned d-flex flex-column gap-1">
                                              {(() => {
                                                const currentAssignments =
                                                  getCurrentAssignedUsersForTask(
                                                    task.taskId
                                                  );

                                                if (
                                                  currentAssignments.length ===
                                                  0
                                                ) {
                                                  return (
                                                    <div className="d-flex align-items-center justify-content-between">
                                                      <span className="text-muted">
                                                        Unassigned
                                                      </span>
                                                      <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() =>
                                                          openTaskDialog(task)
                                                        }
                                                        className="ms-2"
                                                        title="Manage Assignments"
                                                      >
                                                        Assign
                                                      </Button>
                                                    </div>
                                                  );
                                                }

                                                return (
                                                  <>
                                                    {currentAssignments.map(
                                                      (assignment, index) => {
                                                        const userDetail =
                                                          teamMemberDetails.find(
                                                            (user) =>
                                                              String(
                                                                user.userId
                                                              ) ===
                                                              String(
                                                                assignment.assignedUserId
                                                              )
                                                          );
                                                        const userName =
                                                          userDetail?.username ||
                                                          assignment.assignedUserId;

                                                        return (
                                                          <div
                                                            key={
                                                              assignment.assignmentId ||
                                                              index
                                                            }
                                                            className="d-flex align-items-center justify-content-between"
                                                          >
                                                            <div className="d-flex align-items-center">
                                                              <span className="me-2">
                                                                {userName}
                                                              </span>
                                                              <Badge
                                                                bg={
                                                                  assignment.isActive
                                                                    ? "success"
                                                                    : "secondary"
                                                                }
                                                                size="sm"
                                                                className="assignment-status-badge"
                                                              >
                                                                {assignment.isActive
                                                                  ? "Active"
                                                                  : "Completed"}
                                                              </Badge>
                                                              {assignment.totalHours && (
                                                                <small className="ms-2 text-muted">
                                                                  (
                                                                  {parseFloat(
                                                                    assignment.totalHours
                                                                  ).toFixed(2)}
                                                                  h)
                                                                </small>
                                                              )}
                                                            </div>
                                                            {index === 0 && (
                                                              <Button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                onClick={() =>
                                                                  openTaskDialog(
                                                                    task
                                                                  )
                                                                }
                                                                className="ms-2"
                                                                title="Manage Assignments"
                                                              >
                                                                Manage
                                                              </Button>
                                                            )}
                                                          </div>
                                                        );
                                                      }
                                                    )}

                                                    {taskAssignmentsByTask[
                                                      task.taskId
                                                    ]?.length >
                                                      currentAssignments.length && (
                                                      <small className="text-muted">
                                                        +
                                                        {taskAssignmentsByTask[
                                                          task.taskId
                                                        ].length -
                                                          currentAssignments.length}{" "}
                                                        more assignments
                                                      </small>
                                                    )}
                                                  </>
                                                );
                                              })()}
                                            </div>
                                          </td>
                                          <td className="task-priority-cell">
                                            <span
                                              className={`task-priority-badge ${getPriorityBadge(
                                                task.taskPriority
                                              )}`}
                                            >
                                              {task.taskPriority ||
                                                "No Priority"}
                                            </span>
                                          </td>
                                          <td className="task-status-cell">
                                            <span
                                              className={`task-status-badge ${getStatusBadge(
                                                task.taskStatus
                                              )}`}
                                            >
                                              {task.taskStatus || "No Status"}
                                            </span>
                                          </td>
                                          <td className="task-date-cell">
                                            {moment(task.taskStartDate).format(
                                              "MMM DD, YYYY"
                                            )}
                                          </td>
                                          <td className="task-date-cell">
                                            {moment(task.taskEndDate).format(
                                              "MMM DD, YYYY"
                                            )}
                                          </td>
                                          <td className="task-actions-cell">
                                            <div className="task-actions">
                                              <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() =>
                                                  handleEditTask(task.taskId)
                                                }
                                                className="me-2"
                                                title="Edit Task"
                                              >
                                                Edit
                                              </Button>
                                              <Button
                                                variant="outline-danger"
                                                size="sm"
                                                title="Delete Task"
                                              >
                                                Delete
                                              </Button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {/* Show message if no stages and no tasks without stage */}
                      {stages.length === 0 &&
                        !filteredStageTasks["no-stage"]?.length && (
                          <div className="text-center py-4 text-muted">
                            <i className="fas fa-columns fa-2x mb-3"></i>
                            <p>No stages found for this project.</p>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={handleCreateStage}
                            >
                              Create First Stage
                            </Button>
                          </div>
                        )}

                      {/* Show message if there are stages but no tasks at all (including no-stage) */}
                      {stages.length > 0 &&
                        !filteredStageTasks["no-stage"]?.length &&
                        stages.every(
                          (stage) => !filteredStageTasks[stage.stageId]?.length
                        ) && (
                          <div className="text-center py-4 text-muted">
                            <i className="fas fa-tasks fa-2x mb-3"></i>
                            <p>No tasks found in any stage.</p>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() =>
                                navigate(
                                  `/addTask?projectId=${project.projectId}`
                                )
                              }
                            >
                              Add Your First Task
                            </Button>
                          </div>
                        )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "team" && (
              <div className="fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    {/* <h3 className="overview-section-title">Team Details</h3> */}
                    {loadingTeamMembers && (
                      <div className="text-muted">
                        <small>Loading team members...</small>
                      </div>
                    )}
                  </div>

                  {teamData ? (
                    <div className="team-details-container">
                      <div className="overview-grid">
                        <div className="overview-row">
                          <span className="overview-label">Team Name:</span>
                          <span className="overview-value">
                            {teamData.teamName}
                          </span>
                          <span className="overview-label">Team ID:</span>
                          <span className="overview-value">
                            {teamData.teamId}
                          </span>
                        </div>

                        {/* Team Members Section */}
                        <div
                          className="overview-row"
                          style={{ display: "block" }}
                        >
                          <span className="overview-label">Team Members:</span>
                          <div className="team-members-grid mt-3">
                            {teamData.teamMembers &&
                            teamData.teamMembers.length > 0 ? (
                              teamData.teamMembers.map((memberId, index) => {
                                const userInfo = getUserDisplayInfo(memberId);
                                return (
                                  <div key={index} className="team-member-card">
                                    <div className="team-member-avatar">
                                      <i className="fas fa-user"></i>
                                    </div>
                                    <div className="team-member-info">
                                      <div className="team-member-name">
                                        {userInfo.name}
                                      </div>
                                      <div className="team-member-email">
                                        {userInfo.email}
                                      </div>
                                      <div className="team-member-id">
                                        <small className="text-muted">
                                          ID: {memberId}
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="text-center py-4 text-muted">
                                <i className="fas fa-users fa-2x mb-3"></i>
                                <p>No team members found</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <div className="no-team-placeholder">
                        <i className="fas fa-users fa-3x text-muted mb-3"></i>
                        <h5 className="text-muted">No Team Assigned</h5>
                        <p className="text-muted mb-3">
                          This project doesn't have a team assigned yet.
                        </p>
                        {/* <Button variant="outline-primary" size="sm">
                          <i className="fas fa-plus me-2"></i>
                          Assign Team
                        </Button> */}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "ticket" && (
              <div className="fade-in">
                <div className="ticket-list-container">
                  <div className="ticket-list-header">
                    <h4 className="ticket-list-title">Project Tickets</h4>
                    <div className="ticket-list-filters">
                      {/* Ticket filters can go here */}
                    </div>
                  </div>

                  {ticketsLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading tickets...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="ticket-table-container">
                      {tickets.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-ticket-alt fa-3x mb-3"></i>
                          <h5>No Tickets Found</h5>
                          <p className="mb-4">
                            There are no tickets associated with this project.
                          </p>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() =>
                              navigate(
                                `/addTicket?projectId=${project.projectId}`
                              )
                            }
                          >
                            <i className="fas fa-plus me-2"></i>
                            Create First Ticket
                          </Button>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="ticket-table">
                            <thead className="ticket-table-header">
                              <tr>
                                <th>Ticket ID</th>
                                <th>Ticket Name</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Priority</th>
                                <th>Created By</th>
                                <th>Assigned To</th>
                                <th>Category</th>
                                <th>Created Date</th>
                                <th>Due Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="ticket-table-body">
                              {tickets.map((ticket) => (
                                <tr
                                  key={ticket.ticketId}
                                  className="ticket-table-row"
                                >
                                  <td className="ticket-id-cell">
                                    <div className="ticket-id">
                                      {ticket.ticketId}
                                    </div>
                                  </td>
                                  <td className="ticket-name-cell">
                                    <div className="ticket-name">
                                      {ticket.ticketName}
                                    </div>
                                  </td>
                                  <td className="ticket-description-cell">
                                    <div className="ticket-description">
                                      {ticket.description
                                        ? ticket.description.length > 100
                                          ? `${ticket.description.substring(
                                              0,
                                              100
                                            )}...`
                                          : ticket.description
                                        : "-"}
                                    </div>
                                  </td>
                                  <td className="ticket-status-cell">
                                    <span
                                      className={`ticket-status-badge ${getStatusBadge(
                                        ticket.status
                                      )}`}
                                    >
                                      {ticket.status}
                                    </span>
                                  </td>
                                  <td className="ticket-priority-cell">
                                    <span
                                      className={`ticket-priority-badge ${getPriorityBadge(
                                        ticket.priority
                                      )}`}
                                    >
                                      {ticket.priority}
                                    </span>
                                  </td>
                                  <td className="ticket-createdby-cell">
                                    <div className="ticket-createdby">
                                      {ticket.createdBy}
                                    </div>
                                  </td>
                                  <td className="ticket-assignedto-cell">
                                    <div className="ticket-assignedto d-flex flex-column gap-1">
                                      {(() => {
                                        const currentAssignments =
                                          assignmentsByTicket[
                                            ticket.ticketId
                                          ] || [];

                                        if (currentAssignments.length === 0) {
                                          return (
                                            <div className="d-flex align-items-center justify-content-between">
                                              <span className="text-muted">
                                                Unassigned
                                              </span>
                                              <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={() =>
                                                  openTicketDialog(ticket)
                                                }
                                                className="ms-2"
                                                title="Assign user"
                                              >
                                                Assign
                                              </Button>
                                            </div>
                                          );
                                        }

                                        return (
                                          <>
                                            {currentAssignments.map(
                                              (assignment, index) => {
                                                const userDetail =
                                                  teamMemberDetails.find(
                                                    (user) =>
                                                      String(user.userId) ===
                                                      String(
                                                        assignment.assignedUserId
                                                      )
                                                  );
                                                const userName =
                                                  userDetail?.username ||
                                                  assignment.assignedUserId;

                                                return (
                                                  <div
                                                    key={
                                                      assignment.assignmentId ||
                                                      index
                                                    }
                                                    className="d-flex align-items-center justify-content-between"
                                                  >
                                                    <div className="d-flex align-items-center">
                                                      <span className="me-2">
                                                        {userName}
                                                      </span>
                                                      <Badge
                                                        bg={
                                                          assignment.isActive
                                                            ? "success"
                                                            : "secondary"
                                                        }
                                                        className="assignment-status-badge"
                                                      >
                                                        {assignment.isActive
                                                          ? "Active"
                                                          : "Completed"}
                                                      </Badge>
                                                      {assignment.totalHours && (
                                                        <small className="ms-2 text-muted">
                                                          (
                                                          {parseFloat(
                                                            assignment.totalHours
                                                          ).toFixed(2)}
                                                          h)
                                                        </small>
                                                      )}
                                                    </div>

                                                    {/* Only show manage button on first user line */}
                                                    {index === 0 && (
                                                      <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() =>
                                                          openTicketDialog(
                                                            ticket
                                                          )
                                                        }
                                                        className="ms-2"
                                                        title="Manage Assignments"
                                                      >
                                                        Manage
                                                      </Button>
                                                    )}
                                                  </div>
                                                );
                                              }
                                            )}

                                            {currentAssignments.length > 2 && (
                                              <small className="text-muted">
                                                +{currentAssignments.length - 2}{" "}
                                                more assignments
                                              </small>
                                            )}
                                          </>
                                        );
                                      })()}
                                    </div>
                                  </td>

                                  <td className="ticket-category-cell">
                                    <div className="ticket-category">
                                      {ticket.category || "-"}
                                    </div>
                                  </td>
                                  <td className="ticket-date-cell">
                                    {formatDateTime(ticket.ticketTime)}
                                  </td>
                                  <td className="ticket-date-cell">
                                    {formatDate(ticket.dueDate)}
                                  </td>
                                  <td className="ticket-actions-cell">
                                    <div className="ticket-actions">
                                      <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="me-1"
                                        onClick={() => openTicketDialog(ticket)}
                                        title="Open Ticket Details"
                                      >
                                        Open
                                      </Button>

                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() =>
                                          handleConvertToTask(ticket)
                                        }
                                        title="Convert to Task"
                                        className="me-1"
                                      >
                                        Convert to Task
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "workflow" && (
              <div className="fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="overview-section-title">Task Templates</h3>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={handleCreateTemplate}
                    >
                      {/* <i className="fas fa-plus me-2"></i> */}
                      Create Template
                    </Button>
                  </div>

                  {/* Task Templates List */}
                  <div className="templates-container">
                    {templatesLoading ? (
                      <div className="text-center py-4">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">
                            Loading templates...
                          </span>
                        </div>
                      </div>
                    ) : templates.length === 0 ? (
                      <div className="text-center py-5 text-muted">
                        <i className="fas fa-clipboard-list fa-3x mb-3"></i>
                        <h5>No Task Templates</h5>
                        <p>
                          Create your first task template to streamline task
                          creation.
                        </p>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={handleCreateTemplate}
                        >
                          {/* <i className="fas fa-plus me-2"></i> */}
                          Create Your First Template
                        </Button>
                      </div>
                    ) : (
                      <div className="row">
                        {templates.map((template) => (
                          <div
                            key={template.templateId}
                            className="col-md-6 mb-3"
                          >
                            <Card className="template-card h-100">
                              <Card.Body>
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                  <Card.Title className="h6 mb-0">
                                    {template.templateName}
                                  </Card.Title>
                                  <div className="template-actions">
                                    <Button
                                      variant="outline-primary"
                                      size="sm"
                                      className="me-1"
                                      onClick={() =>
                                        handleEditTemplate(template)
                                      }
                                      title="Edit Template"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </Button>
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      onClick={() =>
                                        handleDeleteTemplate(
                                          template.templateId
                                        )
                                      }
                                      title="Delete Template"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </Button>
                                  </div>
                                </div>

                                {template.templateDescription && (
                                  <Card.Text className="text-muted small mb-2">
                                    {template.templateDescription}
                                  </Card.Text>
                                )}

                                <div className="template-fields">
                                  <small className="text-muted">
                                    <strong>Fields included:</strong>{" "}
                                    {
                                      Object.keys(template.includeFields || {})
                                        .length
                                    }
                                  </small>
                                  <div className="field-tags mt-1">
                                    {Object.keys(
                                      template.includeFields || {}
                                    ).map((fieldName) => (
                                      <span
                                        key={fieldName}
                                        className="badge bg-light text-dark me-1 mb-1"
                                      >
                                        {getFieldDisplayName(fieldName)}
                                      </span>
                                    ))}
                                  </div>
                                </div>

                                <div className="template-footer mt-3 pt-2 border-top">
                                  <small className="text-muted">
                                    Created:{" "}
                                    {moment(template.createdOnDate).format(
                                      "MMM DD, YYYY"
                                    )}
                                  </small>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "documents" && (
              <div className="fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h3 className="overview-section-title mb-1">
                        Project Documents
                      </h3>
                      <p className="text-muted mb-0">
                        Manage all documents related to this project
                      </p>
                    </div>
                    <Button
                      variant="primary"
                      onClick={() => setShowUploadModal(true)}
                    >
                      {/* <i className="fas fa-upload me-2"></i> */}
                      Upload Documents
                    </Button>
                  </div>

                  {documentsLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading documents...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="documents-container">
                      {documents.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-folder-open fa-3x mb-3"></i>
                          <h5>No Documents Found</h5>
                          <p className="mb-4">
                            No documents have been uploaded for this project
                            yet.
                          </p>
                          <Button
                            variant="outline-primary"
                            onClick={() => setShowUploadModal(true)}
                          >
                            {/* <i className="fas fa-upload me-2"></i> */}
                            Upload Your First Document
                          </Button>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="document-table">
                            <thead className="document-table-header">
                              <tr>
                                <th>Document Name</th>
                                <th>Type</th>
                                <th>Version</th>
                                <th>Uploaded By</th>
                                <th>Upload Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="document-table-body">
                              {documents.map((doc) => (
                                <tr
                                  key={doc.documentId}
                                  className="document-table-row"
                                >
                                  <td className="document-name-cell">
                                    <div className="document-name">
                                      <i className="fas fa-file me-2 text-primary"></i>
                                      {doc.documentTitle}
                                    </div>
                                  </td>
                                  <td className="document-type-cell">
                                    <Badge
                                      bg="secondary"
                                      className="document-type-badge"
                                    >
                                      {doc.documentType}
                                    </Badge>
                                  </td>
                                  <td className="document-version-cell">
                                    <div className="document-version">
                                      v{doc.documentVersion}
                                    </div>
                                  </td>
                                  <td className="document-uploadedby-cell">
                                    <div className="document-uploadedby">
                                      {doc.createdBy || "Unknown"}
                                    </div>
                                  </td>
                                  <td className="document-date-cell">
                                    {doc.createdOnDate
                                      ? moment(doc.createdOnDate).format(
                                          "MMM DD, YYYY"
                                        )
                                      : "-"}
                                  </td>

                                  <td className="document-actions-cell">
                                    <div className="document-actions">
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() =>
                                          handleDownloadDocument(doc)
                                        }
                                        className="me-2"
                                        title="Download Document"
                                      >
                                        Download
                                      </Button>
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() =>
                                          handleDeleteDocument(
                                            document.documentId,
                                            document.documentTitle
                                          )
                                        }
                                        title="Delete Document"
                                      >
                                        {/* <i className="fas fa-trash"></i> */}
                                        Delete
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Upload Document Modal */}
                <Modal
                  show={showUploadModal}
                  onHide={() => setShowUploadModal(false)}
                  size="lg"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Upload Documents</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Label>Document Title</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter document title"
                          value={documentTitle}
                          onChange={(e) => setDocumentTitle(e.target.value)}
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Document Type</Form.Label>
                        <Form.Select
                          value={documentType}
                          onChange={(e) => setDocumentType(e.target.value)}
                        >
                          <option value="">-- Select Document Type --</option>
                          <option value="Report">Report</option>
                          <option value="Invoice">Invoice</option>
                          <option value="Contract">Contract</option>

                          <option value="Presentation">Presentation</option>

                          <option value="PO">PO</option>
                          <option value="SOW">SOW</option>
                          <option value="Proposal">Proposal</option>
                          <option value="WSR">WSR</option>
                          <option value="Project Plan">Project Plan</option>
                          <option value="Other">Other</option>
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Select Files</Form.Label>
                        <Form.Control
                          type="file"
                          multiple
                          onChange={handleFileSelect}
                          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.gif,.txt,.zip,.rar"
                        />
                        <Form.Text className="text-muted">
                          Maximum file size: 25MB per file. Supported formats:
                          PDF, Word, Excel, PowerPoint, Images, Text, Archives
                        </Form.Text>
                      </Form.Group>

                      {selectedFiles.length > 0 && (
                        <div className="selected-files-list">
                          <h6>Selected Files ({selectedFiles.length}):</h6>
                          <ul className="list-group">
                            {selectedFiles.map((file, index) => (
                              <li
                                key={index}
                                className="list-group-item d-flex justify-content-between align-items-center"
                              >
                                <div>
                                  <i className="fas fa-file me-2 text-primary"></i>
                                  {file.name}
                                </div>
                                <Badge bg="light" text="dark">
                                  {(file.size / (1024 * 1024)).toFixed(2)} MB
                                </Badge>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </Form>
                  </Modal.Body>

                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setShowUploadModal(false);
                        setSelectedFiles([]);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="primary"
                      onClick={handleUploadDocuments}
                      disabled={
                        selectedFiles.length === 0 || uploadingDocuments
                      }
                    >
                      {uploadingDocuments ? (
                        <>
                          <div
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Uploading...
                            </span>
                          </div>
                          Uploading...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-upload me-2"></i>
                          Upload {selectedFiles.length} File(s)
                        </>
                      )}
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            )}

            {activeTab === "partner" && (
              <div className="fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h3 className="overview-section-title mb-1">
                        Project Partners
                      </h3>
                      <p className="text-muted mb-0">
                        Manage partners associated with this project
                      </p>
                    </div>
                    <Button variant="primary" onClick={handleCreatePartner}>
                      {/* <i className="fas fa-plus me-2"></i> */}
                      Add Partner
                    </Button>
                  </div>

                  {partnersLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading partners...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="partners-container">
                      {partners.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-handshake fa-3x mb-3"></i>
                          <h5>No Partners Found</h5>
                          <p className="mb-4">
                            No partners are associated with this project yet.
                          </p>
                          <Button
                            variant="outline-primary"
                            onClick={handleCreatePartner}
                          >
                            <i className="fas fa-plus me-2"></i>
                            Add Your First Partner
                          </Button>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="partner-table">
                            <thead className="partner-table-header">
                              <tr>
                                <th>Partner ID</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Roles</th>
                                <th>Created By</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="partner-table-body">
                              {partners.map((partner) => (
                                <tr
                                  key={partner.partnerId}
                                  className="partner-table-row"
                                >
                                  <td className="partner-id-cell">
                                    <div className="partner-id">
                                      {partner.partnerId}
                                    </div>
                                  </td>
                                  <td className="partner-name-cell">
                                    <div className="partner-name">
                                      {partner.partnerName}
                                    </div>
                                  </td>
                                  <td className="partner-email-cell">
                                    <div className="partner-email">
                                      {partner.partnerEmailId || "-"}
                                    </div>
                                  </td>
                                  <td className="partner-phone-cell">
                                    <div className="partner-phone">
                                      {partner.partnerPhoneNo || "-"}
                                    </div>
                                  </td>
                                  <td className="partner-roles-cell">
                                    <div className="partner-roles">
                                      {formatRoles(
                                        parsePartnerRoles(partner.partnerRole)
                                      )}
                                    </div>
                                  </td>
                                  <td className="partner-createdby-cell">
                                    <div className="partner-createdby">
                                      {partner.createdBy || "-"}
                                    </div>
                                  </td>
                                  <td className="partner-date-cell">
                                    {partner.createdOnDate
                                      ? moment(partner.createdOnDate).format(
                                          "MMM DD, YYYY"
                                        )
                                      : "-"}
                                  </td>
                                  <td className="partner-actions-cell">
                                    <div className="partner-actions">
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() =>
                                          handleEditPartner(partner)
                                        }
                                        className="me-2"
                                        title="Edit Partner"
                                      >
                                        Edit
                                        {/* <i className="fas fa-edit"></i> */}
                                      </Button>
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        title="Delete Partner"
                                      >
                                        Trash
                                        {/* <i className="fas fa-trash"></i> */}
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "commercials" && (
              <div className="fade-in">
                <div className="project-overview-single-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    {/* <div>
                      <h3 className="overview-section-title mb-1">
                        Project Commercials
                      </h3>
                      <p className="text-muted mb-0">
                        Manage commercial information and revenue projections
                      </p>
                    </div> */}
                    <Button variant="primary" onClick={handleCreateCommercial}>
                      Add Commercial
                    </Button>
                  </div>

                  {commercialsLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading commercials...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="commercials-container">
                      {commercials.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-chart-line fa-3x mb-3"></i>
                          <h5>No Commercials Found</h5>
                          <p className="mb-4">
                            No commercial information is available for this
                            project yet.
                          </p>
                          <Button
                            variant="outline-primary"
                            onClick={handleCreateCommercial}
                          >
                            Add Your First Commercial
                          </Button>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="commercial-table">
                            <thead className="commercial-table-header">
                              <tr>
                                <th>Commercial ID</th>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Planned Revenue</th>
                                <th>Type</th>
                                <th>Currency</th>
                                <th>Created By</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="commercial-table-body">
                              {commercials.map((commercial) => (
                                <tr
                                  key={commercial.commercialId}
                                  className="commercial-table-row"
                                >
                                  <td className="commercial-id-cell">
                                    <div className="commercial-id">
                                      {commercial.commercialId}
                                    </div>
                                  </td>
                                  <td className="commercial-title-cell">
                                    <div className="commercial-title">
                                      {commercial.commercialTitle}
                                    </div>
                                  </td>
                                  <td className="commercial-description-cell">
                                    <div className="commercial-description">
                                      {commercial.commercialDescription || "-"}
                                    </div>
                                  </td>

                                  <td className="commercial-revenue-cell">
                                    <div className="commercial-revenue">
                                      {formatCurrencyDisplay(
                                        commercial.commercialPlannedRevenue,
                                        commercial.commercialCurrency
                                      )}
                                    </div>
                                  </td>
                                  <td className="commercial-type-cell">
                                    <div className="commercial-type">
                                      {commercial.commercialType || "-"}
                                    </div>
                                  </td>
                                  <td className="commercial-createdby-cell">
                                    <div className="commercial-createdby">
                                      {commercial.createdBy || "-"}
                                    </div>
                                  </td>
                                  <td className="commercial-date-cell">
                                    {commercial.createdOnDate
                                      ? moment(commercial.createdOnDate).format(
                                          "MMM DD, YYYY"
                                        )
                                      : "-"}
                                  </td>
                                  <td className="commercial-actions-cell">
                                    <div className="commercial-actions">
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() =>
                                          handleEditCommercial(commercial)
                                        }
                                        className="me-2"
                                        title="Edit Commercial"
                                        style={{ padding: "6px" }}
                                      >
                                        Edit
                                      </Button>
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        title="Delete Commercial"
                                        style={{ padding: "6px" }}
                                      >
                                        Delete
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "milestone" && (
              <div className="fade-in">
                <div className="project-overview-single-card">
                  <div
                    className="d-flex justify-content-between align-items-center mb-4"
                    style={{ margin: "15px" }}
                  >
                    <div>
                      <h3 className="overview-section-title mb-1">
                        Project Milestones
                      </h3>
                      <p className="text-muted mb-0">
                        Track and manage project milestones and deliverables
                      </p>
                    </div>
                    <Button variant="primary" onClick={handleCreateMilestone}>
                      Add Milestone
                    </Button>
                  </div>

                  {milestonesLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading milestones...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="milestones-container">
                      {milestones.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                          <i className="fas fa-flag fa-3x mb-3"></i>
                          <h5>No Milestones Found</h5>
                          <p className="mb-4">
                            No milestones are defined for this project yet.
                          </p>
                          <Button
                            variant="outline-primary"
                            onClick={handleCreateMilestone}
                          >
                            Add Your First Milestone
                          </Button>
                        </div>
                      ) : (
                        <div className="table-responsive">
                          <table className="milestone-table">
                            <thead className="milestone-table-header">
                              <tr>
                                <th style={{ width: "40px" }}>Drop</th>
                                <th>Milestone ID</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Percentage</th>
                                <th>Planned Dates</th>
                                <th>Actual Dates</th>
                                <th>Status</th>
                                <th>Description</th>
                                <th>Created By</th>
                                <th>Created Date</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="milestone-table-body">
                              {milestones.map((milestone) => (
                                <React.Fragment
                                  key={milestone.milestoneMavroId}
                                >
                                  <tr className="milestone-table-row">
                                    <td className="milestone-expand-cell">
                                      <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="expand-btn"
                                        onClick={() =>
                                          toggleMilestoneExpand(
                                            milestone.milestoneMavroId
                                          )
                                        }
                                        title={
                                          expandedMilestones[
                                            milestone.milestoneMavroId
                                          ]
                                            ? "Collapse tasks"
                                            : "Expand tasks"
                                        }
                                      >
                                        {expandedMilestones[
                                          milestone.milestoneMavroId
                                        ]
                                          ? "down"
                                          : "up"}
                                      </Button>
                                    </td>
                                    <td className="milestone-id-cell">
                                      <div className="milestone-id">
                                        {milestone.milestoneMavroId}
                                      </div>
                                    </td>
                                    <td className="milestone-name-cell">
                                      <div className="milestone-name">
                                        {milestone.name}
                                      </div>
                                    </td>
                                    <td className="milestone-type-cell">
                                      <div className="milestone-type">
                                        {milestone.type || "-"}
                                      </div>
                                    </td>
                                    <td className="milestone-percentage-cell">
                                      <div className="milestone-percentage">
                                        {milestone.calculatedPercentage !==
                                        undefined ? (
                                          <div>
                                            <div className="percentage-value">
                                              {milestone.calculatedPercentage}%
                                            </div>
                                            <div className="percentage-details small text-muted">
                                              {milestone.completedTasks}/
                                              {milestone.totalTasks} tasks
                                            </div>
                                          </div>
                                        ) : milestone.percentage ? (
                                          `${milestone.percentage}%`
                                        ) : (
                                          "-"
                                        )}
                                      </div>
                                    </td>
                                    <td className="milestone-planned-dates-cell">
                                      <div className="milestone-dates">
                                        <div>
                                          <small className="text-muted">
                                            Start:
                                          </small>{" "}
                                          {formatDate(
                                            milestone.plannedStartDate
                                          )}
                                        </div>
                                        <div>
                                          <small className="text-muted">
                                            End:
                                          </small>{" "}
                                          {formatDate(milestone.plannedEndDate)}
                                        </div>
                                      </div>
                                    </td>
                                    <td className="milestone-actual-dates-cell">
                                      <div className="milestone-dates">
                                        <div>
                                          <small className="text-muted">
                                            Start:
                                          </small>{" "}
                                          {formatDate(
                                            milestone.actualStartDate
                                          ) || "-"}
                                        </div>
                                        <div>
                                          <small className="text-muted">
                                            End:
                                          </small>{" "}
                                          {formatDate(
                                            milestone.actualEndDate
                                          ) || "-"}
                                        </div>
                                      </div>
                                    </td>
                                    <td className="milestone-status-cell">
                                      <span
                                        className={`milestone-status-badge ${getStatusBadge(
                                          milestone.status
                                        )}`}
                                      >
                                        {milestone.status}
                                      </span>
                                    </td>
                                    <td className="milestone-description-cell">
                                      <div className="milestone-description">
                                        {milestone.description
                                          ? milestone.description.length > 50
                                            ? `${milestone.description.substring(
                                                0,
                                                50
                                              )}...`
                                            : milestone.description
                                          : "-"}
                                      </div>
                                    </td>
                                    <td className="milestone-createdby-cell">
                                      <div className="milestone-createdby">
                                        {milestone.createdBy || "-"}
                                      </div>
                                    </td>
                                    <td className="milestone-date-cell">
                                      {milestone.createdOnDate
                                        ? formatDate(milestone.createdOnDate)
                                        : "-"}
                                    </td>
                                    <td className="milestone-actions-cell">
                                      <div className="milestone-actions">
                                        <Button
                                          variant="outline-primary"
                                          size="sm"
                                          onClick={() =>
                                            handleEditMilestone(milestone)
                                          }
                                          className="me-2"
                                          title="Edit Milestone"
                                        >
                                          Edit
                                        </Button>
                                        <Button
                                          variant="outline-danger"
                                          size="sm"
                                          onClick={() =>
                                            console.log(
                                              "trying to delete milestone"
                                            )
                                          }
                                          title="Delete Milestone"
                                        >
                                          Delete
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>

                                  {/* Expanded tasks row */}
                                  {expandedMilestones[
                                    milestone.milestoneMavroId
                                  ] && (
                                    <tr className="milestone-tasks-row">
                                      <td
                                        colSpan="12"
                                        className="milestone-tasks-container"
                                      >
                                        <div className="milestone-tasks-content">
                                          <h6 className="tasks-section-title">
                                            Tasks Assigned to this Milestone
                                            <Badge
                                              bg="secondary"
                                              className="ms-2"
                                            >
                                              {milestoneTasks[
                                                milestone.milestoneMavroId
                                              ]?.length || 0}{" "}
                                              tasks
                                            </Badge>
                                          </h6>

                                          {milestoneTasks[
                                            milestone.milestoneMavroId
                                          ]?.length > 0 ? (
                                            <div className="table-responsive">
                                              <table className="task-subtable">
                                                <thead className="task-subtable-header">
                                                  <tr>
                                                    <th>Task ID</th>
                                                    <th>Task Name</th>
                                                    <th>Description</th>
                                                    <th>Assigned To</th>
                                                    <th>Priority</th>
                                                    <th>Status</th>
                                                    <th>Start Date</th>
                                                    <th>End Date</th>
                                                    <th>Actions</th>
                                                  </tr>
                                                </thead>
                                                <tbody className="task-subtable-body">
                                                  {milestoneTasks[
                                                    milestone.milestoneMavroId
                                                  ].map((task) => (
                                                    <tr
                                                      key={task.taskId}
                                                      className="task-subtable-row"
                                                    >
                                                      <td className="task-id-cell">
                                                        <div className="task-id">
                                                          {task.taskId}
                                                        </div>
                                                      </td>
                                                      <td className="task-name-cell">
                                                        <div
                                                          className="task-name clickable-task-name"
                                                          onClick={() =>
                                                            handleTaskNameClick(
                                                              task.taskId
                                                            )
                                                          }
                                                          title="Click to view task details"
                                                        >
                                                          {task.taskName}
                                                        </div>
                                                      </td>
                                                      <td className="task-description-cell">
                                                        <div className="task-description">
                                                          {task.taskDescription ||
                                                            "-"}
                                                        </div>
                                                      </td>
                                                      <td className="task-assigned-cell">
                                                        <div className="task-assigned">
                                                          {taskAssignedUsers[
                                                            parseInt(
                                                              task.assignedTo
                                                            )
                                                          ] ||
                                                            task.assignedTo ||
                                                            "Unassigned"}
                                                        </div>
                                                      </td>
                                                      <td className="task-priority-cell">
                                                        <span
                                                          className={`task-priority-badge ${getPriorityBadge(
                                                            task.taskPriority
                                                          )}`}
                                                        >
                                                          {task.taskPriority}
                                                        </span>
                                                      </td>
                                                      <td className="task-status-cell">
                                                        <span
                                                          className={`task-status-badge ${getStatusBadge(
                                                            task.taskStatus
                                                          )}`}
                                                        >
                                                          {task.taskStatus}
                                                        </span>
                                                      </td>
                                                      <td className="task-date-cell">
                                                        {moment(
                                                          task.taskStartDate
                                                        ).format(
                                                          "MMM DD, YYYY"
                                                        )}
                                                      </td>
                                                      <td className="task-date-cell">
                                                        {moment(
                                                          task.taskEndDate
                                                        ).format(
                                                          "MMM DD, YYYY"
                                                        )}
                                                      </td>
                                                      <td className="task-actions-cell">
                                                        <div className="task-actions">
                                                          <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() =>
                                                              handleEditTask(
                                                                task.taskId
                                                              )
                                                            }
                                                            className="me-2"
                                                            title="Edit Task"
                                                          >
                                                            Edit
                                                          </Button>
                                                          <Button
                                                            variant="outline-danger"
                                                            size="sm"
                                                            title="Delete Task"
                                                          >
                                                            Delete
                                                          </Button>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                            </div>
                                          ) : (
                                            <div className="text-center py-3 text-muted">
                                              <i className="fas fa-tasks fa-2x mb-2"></i>
                                              <p>
                                                No tasks assigned to this
                                                milestone
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "resourceAllocation" && (
              <div className="fade-in">
                <div className="resource-allocation-section">
                  <div
                    className="d-flex justify-content-between align-items-center mb-4"
                    style={{ margin: "15px" }}
                  >
                    <h4 className="mb-0">Resource Allocation</h4>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={handleCreateResource}
                    >
                      Add Resource
                    </Button>
                  </div>

                  {resourcesLoading ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          Loading resources...
                        </span>
                      </div>
                      <p className="mt-2 text-muted">Loading resources...</p>
                    </div>
                  ) : resources.length === 0 ? (
                    <div className="text-center py-5">
                      <i className="fas fa-users fa-3x text-muted mb-3"></i>
                      <h5 className="text-muted">No Resources Allocated</h5>
                      <p className="text-muted">
                        No resources have been allocated to this project yet.
                      </p>
                      {/* <Button variant="primary" onClick={handleCreateResource}>
                        Add First Resource
                      </Button> */}
                    </div>
                  ) : (
                    <div className="resource-table-container">
                      <div className="table-responsive">
                        <table className="table table-striped table-hover">
                          <thead className="table-resource">
                            <tr>
                              {/* <th>Resource ID</th> */}
                              <th>Member</th>
                              <th>Role</th>
                              <th>Billable</th>
                              <th>Allocation %</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Status</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody className="table-resource">
                            {resources.map((resource) => {
                              // Find user details for this resource member
                              const userDetail = teamMemberDetails.find(
                                (user) =>
                                  user.userId ===
                                  parseInt(resource.resourceMember)
                              );

                              // Get display name - username if available, otherwise fallback to ID
                              const displayName = userDetail
                                ? userDetail.username
                                : resource.resourceMember;

                              return (
                                <tr key={resource.resourceId}>
                                  {/* <td>
                        <Badge
                          bg="secondary"
                          className="resource-id-badge"
                        >
                          {resource.resourceId}
                        </Badge>
                      </td> */}
                                  <td>
                                    <strong>{displayName}</strong>
                                    {userDetail && userDetail.email && (
                                      <div className="text-muted small">
                                        {userDetail.email}
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    <span className="resource-role">
                                      {resource.resourceRole}
                                    </span>
                                  </td>
                                  <td>
                                    <Badge
                                      bg={
                                        resource.resourceBillable === "Billable"
                                          ? "success"
                                          : "warning"
                                      }
                                      className="billable-badge"
                                    >
                                      {resource.resourceBillable}
                                    </Badge>
                                  </td>
                                  <td>
                                    <div className="allocation-percentage">
                                      <small className="text-muted">
                                        {resource.resourceAllocaPercentage}%
                                      </small>
                                    </div>
                                  </td>
                                  <td>
                                    {formatDate(resource.resourceStartDate)}
                                  </td>
                                  <td>
                                    {formatDate(resource.resourceEndDate)}
                                  </td>
                                  <td>
                                    <Badge
                                      className={getResourceStatusBadge(
                                        resource.resourceStatus
                                      )}
                                    >
                                      {resource.resourceStatus}
                                    </Badge>
                                  </td>
                                  <td>
                                    <div className="btn-group" role="group">
                                      <Button
                                        variant="outline-primary"
                                        size="sm"
                                        onClick={() =>
                                          handleEditResource(resource)
                                        }
                                        title="Edit Resource"
                                      >
                                        Edit
                                      </Button>
                                      <Button
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() =>
                                          handleDeleteResource(
                                            resource.resourceId
                                          )
                                        }
                                        title="Delete Resource"
                                      >
                                        Delete
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "budget" && (
              <div className="fade-in text-center py-5">
                <h4>Project Budget</h4>
                <p className="text-muted">
                  Budget management features coming soon...
                </p>
              </div>
            )}

            {activeTab === "settings" && (
              <div className="fade-in text-center py-5">
                <h4>Project Settings</h4>
                <p className="text-muted">
                  Project settings features coming soon...
                </p>
              </div>
            )}
          </div>
        </div>
      </Container>

      {/* Task Edit Modal */}
      <TaskEditModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        taskId={selectedTaskId}
        onTaskUpdated={handleTaskUpdated}
      />

      {/* Task View Sidebar */}
      <TaskViewSidebar
        show={showTaskSidebar}
        onHide={() => setShowTaskSidebar(false)}
        taskId={selectedTaskId}
        onTaskUpdated={() => {
          loadProjectTasks();
        }}
      />

      {/* Task Template Modal */}
      <TaskTemplateModal
        show={showTemplateModal}
        onHide={() => setShowTemplateModal(false)}
        template={selectedTemplate}
        orgId={orgId}
        onTemplateSaved={handleTemplateSaved}
      />

      {/* Partner Modal */}
      <PartnerModal
        show={showPartnerModal}
        onHide={handleClosePartnerModal}
        partner={editingPartner}
        orgId={orgId}
        projectId={projectId}
        onPartnerSaved={handlePartnerSaved}
      />

      {/* Stage Modal */}
      <StageModal
        show={showStageModal}
        onHide={handleCloseStageModal}
        stage={editingStage}
        orgId={orgId}
        projectId={projectId}
        onStageSaved={handleStageSaved}
      />

      {/* Commercial Modal */}
      <CommercialModal
        show={showCommercialModal}
        onHide={handleCloseCommercialModal}
        commercial={editingCommercial}
        projectId={projectId}
        onCommercialSaved={handleCommercialSaved}
      />

      {/* Milestone Modal */}
      <MilestoneModal
        show={showMilestoneModal}
        onHide={handleCloseMilestoneModal}
        milestone={editingMilestone}
        projectId={projectId}
        onMilestoneSaved={handleMilestoneSaved}
      />

      {/* Resource Modal */}
      <ResourceModal
        show={showResourceModal}
        onHide={handleCloseResourceModal}
        resource={editingResource}
        projectId={projectId}
        teamAssigned={project?.teamAssigned}
        onResourceSaved={handleResourceSaved}
      />

      <Modal
        show={showTicketDialog}
        onHide={closeTicketDialog}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Ticket: {ticketForDialog?.ticketId} •{" "}
            <span style={{ fontWeight: 400 }}>
              {ticketForDialog?.ticketName}
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Important details */}
          <Card className="mb-3">
            <Card.Body>
              <Row className="mb-2">
                <Col xs={6}>
                  <small className="text-muted">Status</small>
                  <div>
                    <span
                      className={`ticket-status-badge ${getStatusBadge(
                        ticketForDialog?.status
                      )}`}
                    >
                      {ticketForDialog?.status || "-"}
                    </span>
                  </div>
                </Col>
                <Col xs={6}>
                  <small className="text-muted">Priority</small>
                  <div
                    className={`ticket-priority-badge ${getPriorityBadge(
                      ticketForDialog?.priority
                    )}`}
                  >
                    {ticketForDialog?.priority || "-"}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <small className="text-muted">Created</small>
                  <div>{formatDateTime(ticketForDialog?.ticketTime)}</div>
                </Col>
                <Col xs={6}>
                  <small className="text-muted">Due</small>
                  <div>{formatDate(ticketForDialog?.dueDate)}</div>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Assign member (team members only) */}
          <Card className="mb-3">
            <Card.Header className="py-2">
              <strong>Assign a team member</strong>
            </Card.Header>
            <Card.Body className="py-3">
              <Row className="g-2">
                <Col xs={8}>
                  <Form.Select
                    value={assignUserId}
                    onChange={(e) => setAssignUserId(e.target.value)}
                    disabled={assignLoading || assignmentsLoading}
                  >
                    <option value="">Select team member...</option>
                    {teamMemberDetails.map((u) => {
                      const active = getActiveAssignmentForUser(
                        ticketForDialog?.ticketId,
                        u.userId
                      );
                      return (
                        <option key={u.userId} value={u.userId}>
                          {u.username} ({u.userId})
                          {active ? " • Active session running" : ""}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>
                <Col xs={4}>
                  <Button
                    variant="primary"
                    className="w-100"
                    onClick={handleAssignAndStart}
                    disabled={assignLoading || !assignUserId}
                  >
                    {assignLoading ? "Starting..." : "Assign & Start"}
                  </Button>
                </Col>
              </Row>
              <small className="text-muted d-block mt-2">
                Only members of the project’s assigned team are listed.
              </small>
            </Card.Body>
          </Card>

          {/* Current assignments list */}
          <Card>
            <Card.Header className="py-2 d-flex justify-content-between align-items-center">
              <strong>Assignments on this ticket</strong>
              {assignmentsLoading && (
                <span className="text-muted" style={{ fontSize: 12 }}>
                  loading...
                </span>
              )}
            </Card.Header>
            <Card.Body className="py-2">
              {(assignmentsByTicket[ticketForDialog?.ticketId] || []).length ===
              0 ? (
                <div className="text-muted">No assignments yet</div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Hours</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ...(assignmentsByTicket[ticketForDialog?.ticketId] ||
                          []),
                      ]
                        .sort(
                          (a, b) =>
                            new Date(b.startTime || 0) -
                            new Date(a.startTime || 0)
                        )
                        .map((a) => {
                          const userInfo = teamMemberDetails.find(
                            (u) => String(u.userId) === String(a.assignedUserId)
                          );
                          const name =
                            userInfo?.username || `User ${a.assignedUserId}`;
                          const active =
                            a.isActive === true || a.isActive === 1;

                          return (
                            <tr key={a.assignmentId}>
                              <td>{name}</td>
                              <td>{formatDateTime(a.startTime)}</td>
                              <td>
                                {a.endTime ? formatDateTime(a.endTime) : "-"}
                              </td>
                              <td>{fmtHours(a.totalHours)}</td>
                              <td>
                                {active ? (
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => handleStop(a.assignmentId)}
                                  >
                                    Stop
                                  </Button>
                                ) : (
                                  <Badge bg="secondary">Stopped</Badge>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              )}
            </Card.Body>
          </Card>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeTicketDialog}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ======================= TASK ASSIGNMENT DIALOG ======================= */}
      <Modal
        show={showTaskDialog}
        onHide={closeTaskDialog}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Manage Task Assignment</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {taskForDialog ? (
            <>
              <h5>{taskForDialog.taskName}</h5>
              <p className="text-muted">
                {taskForDialog.taskDescription || "No description"}
              </p>

              <div className="mb-3">
                <strong>Planned:</strong>{" "}
                {formatDate(taskForDialog.taskStartDate)} →{" "}
                {formatDate(taskForDialog.taskEndDate)}
              </div>

              <Form.Group className="mb-3">
                <Form.Label>Assign Team Member</Form.Label>
                <Form.Select
                  value={assignTaskUserId}
                  onChange={(e) => setAssignTaskUserId(e.target.value)}
                  disabled={taskAssignLoading}
                >
                  <option value="">Select a team member</option>
                  {teamMemberDetails.map((user) => (
                    <option key={user.userId} value={user.userId}>
                      {user.username}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <div className="d-flex justify-content-end mb-4">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={handleAssignAndStartTask}
                  disabled={taskAssignLoading}
                >
                  {taskAssignLoading ? "Starting..." : "Start Work"}
                </Button>
              </div>

              <hr />

              <h6>Assignment History</h6>
              {taskAssignLoading ? (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm text-primary" />
                </div>
              ) : taskAssignments.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Total Hours</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    {/* In the assignment history table section of the dialog */}
                    <tbody>
                      {taskAssignments.map((assign) => {
                        const userName = getUsernameFromId(
                          assign.assignedUserId
                        );

                        return (
                          <tr key={assign.assignmentId}>
                            <td>{userName}</td>
                            <td>{formatDateTime(assign.startTime)}</td>
                            <td>
                              {formatDateTime(assign.endTime) || "Ongoing"}
                            </td>
                            <td>{fmtHours(assign.totalHours)}</td>
                            <td>
                              <Badge
                                bg={assign.isActive ? "success" : "secondary"}
                              >
                                {assign.isActive
                                  ? "Active"
                                  : assign.autoStopped
                                  ? "Auto-Stopped"
                                  : "Completed"}
                              </Badge>
                            </td>
                            <td>
                              {assign.isActive ? (
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() =>
                                    handleStopTaskWork(assign.assignmentId)
                                  }
                                >
                                  Stop
                                </Button>
                              ) : (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  onClick={async () => {
                                    try {
                                      await startTaskWork(
                                        taskForDialog.taskId,
                                        assign.assignedUserId,
                                        orgId
                                      );
                                      toast.success(
                                        "Task work session restarted"
                                      );
                                      await refreshTaskAssignments(
                                        taskForDialog.taskId
                                      );
                                    } catch (error) {
                                      toast.error("Failed to restart work");
                                    }
                                  }}
                                  title="Restart work"
                                >
                                  Restart
                                </Button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">
                  No assignment history found for this task.
                </p>
              )}
            </>
          ) : (
            <div className="text-center text-muted">No task selected</div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeTaskDialog}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Excel Upload Modal */}
      <Modal
        show={showExcelUploadModal}
        onHide={handleCloseExcelUploadModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-file-excel me-2 text-success"></i>
            Upload Tasks from Excel
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="excel-upload-container">
            <div className="mb-4">
              <h5>Instructions:</h5>
              <ul className="small">
                <li>Download the template to see the required format</li>
                <li>Supported formats: .xlsx, .xls, .csv</li>
                <li>
                  Required columns: taskName, taskDescription, assignedTo,
                  taskStartDate, taskEndDate
                </li>
                <li>Optional columns: taskPriority, taskStatus, taskType</li>
                <li>Dates should be in YYYY-MM-DD format</li>
              </ul>
            </div>

            <div className="mb-4">
              <Button
                variant="outline-success"
                onClick={handleDownloadTemplate}
                className="mb-3"
              >
                <i className="fas fa-download me-2"></i>
                Download Excel Template
              </Button>
            </div>

            <Form.Group className="mb-4">
              <Form.Label>Select Excel File:</Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx,.xls,.csv"
                onChange={handleExcelFileSelect}
              />
              <Form.Text className="text-muted">
                {excelFile ? `Selected: ${excelFile.name}` : "No file selected"}
              </Form.Text>
            </Form.Group>

            <div className="upload-info-card p-3 bg-light rounded">
              <h6 className="mb-2">Upload Information:</h6>
              <div className="row">
                <div className="col-md-6">
                  <small>
                    <strong>Organization ID:</strong> {orgId}
                  </small>
                </div>
                <div className="col-md-6">
                  <small>
                    <strong>Project ID:</strong> {project?.projectId}
                  </small>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-12">
                  <small>
                    <strong>Project:</strong> {project?.prTitle}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseExcelUploadModal}
            disabled={uploadingExcel}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleExcelUpload}
            disabled={!excelFile || uploadingExcel}
          >
            {uploadingExcel ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Uploading...
              </>
            ) : (
              <>
                <i className="fas fa-upload me-2"></i>
                Upload & Create Tasks
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProjectView;
